import moment, { Moment } from "moment-timezone";
import { ChangeEvent, Component } from "react";
import "./CreateCatalogItemSidebar.scss";
import { NumericFormat } from "react-number-format";
import * as _ from "lodash-es";
import taxJarLogo from "@assets/images/taxjar/taxjar-logotype-dark.svg";
import taxJarLightLogo from "@assets/images/taxjar/taxjar-logotype.svg";
import ICreateCatalogItemDTO from "@models/DTO/ICreateCatalogItemDTO";
import IDeleteFileUploadDTO from "@models/DTO/IDeleteFileUploadDTO";
import IOnCreateCatalogItemDTO from "@models/DTO/IOnCreateCatalogItemDTO";
import IOnCreateFileUploadDTO from "@models/DTO/IOnCreateFileUploadDTO";
import IOnDeleteFileUploadDTO from "@models/DTO/IOnDeleteFileUploadDTO";
import IOnGetCatalogItemDTO from "@models/DTO/IOnGetCatalogItemDTO";
import IOnUpdateCatalogItemDTO from "@models/DTO/IOnUpdateCatalogItemDTO";
import ITaxJarGetTaxCategoriesDTO from "@models/DTO/ITaxJarGetTaxCategoriesDTO";
import ITaxJarOnGetTaxCategoriesDTO from "@models/DTO/ITaxJarOnGetTaxCategoriesDTO";
import IUpdateCatalogItemDTO from "@models/DTO/IUpdateCatalogItemDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import FileUploadResourceTypeEnum from "@models/FileUploadResourceTypeEnum";
import IAttachment from "@models/IAttachment";
import ICatalog_Item from "@models/ICatalog_Item";
import ICatalog_ItemUI from "@models/ICatalog_ItemUI";
import ICatalog_Item_Attribute from "@models/ICatalog_Item_Attribute";
import IVendor_Source_Location_Map_Item from "@models/ICategory_Vendor_Source_Location_Map_Item";
import IGroupItem from "@models/IGroupItem";
import IKit_Catalog_Items_MapUI from "@models/IKit_Catalog_Items_MapUI";
import IMaterial from "@models/IMaterial";
import INew_Material_Catalog_Item_Map from "@models/INew_Material_Catalog_Item_Map";
import INewKit_Catalog_Items_MapUI from "@models/INewKit_Catalog_Items_MapUI";
import ITaxJar_Category from "@models/ITaxJar_Category";
import IVendor_Source from "@models/IVendor_Source";
import IVendor_Source_Location from "@models/IVendor_Source_Location";
import IVendor_Source_LocationUI from "@models/IVendor_Source_LocationUI";
import IVendorSourceItem from "@models/IVendorSourceItem";
import IVendorSourceLocationItem from "@models/IVendorSourceLocationItem";
import IWarehouse_Catalog_Items_Map from "@models/IWarehouse_Catalog_Items_Map";
import IWarehouseItem from "@models/IWarehouseItem";
import CatalogItemService from "@services/CatalogItemService";
import SystemConst from "@services/SystemConst";
import UIService from "@services/UIService";
import OwButton from "@components/shared/OwButton/OwButton";
import { OwCatalogImagePhotoSet } from "@components/shared/OwCatalogImagePhotoSet/OwCatalogImagePhotoSet";
import { OwCharCount } from "@components/shared/OwCharCount/OwCharCount";
import OwDateInput from "@components/shared/OwDateInput/OwDateInput";
import OwS3DownloadLink from "@components/shared/OwS3DownloadLink/OwS3DownloadLink";
import OwS3Uploader from "@components/shared/OwS3Uploader/OwS3Uploader";
import OwTextArea from "@components/shared/OwTextArea/OwTextArea";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { FormattedMessage, FormattedNumber } from "react-intl";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwInputWrapper from "@components/shared/OwInputWrapper/OwInputWrapper";
import OwCheckbox from "@components/shared/OwCheckbox/OwCheckbox";
import OwTranslate from "@components/shared/OwTranslate/OwTranslate";
import IErrorDTO from "@models/DTO/IErrorDTO";
import INotification from "@models/INotification";
import NotificationPositionEnum from "@models/NotificationPositionEnum";
import NotificationLevelEnum from "@models/NotificationLevelEnum";
import ISupplierModel from "@models/ISupplierModel";
import IPrice_Group from "@models/IPrice_Group";
import IUserUI from "@models/IUserUI";
import Typeahead from "@components/shared/Typeahead/Typeahead";
import CategorySelection from "./CategorySelection/CategorySelection";
import { KitDetail } from "./KitDetail/KitDetail";
import MaterialsDetail from "./MaterialsDetail/MaterialsDetail";
import BomDetail from "./BomDetail/BomDetail";
import IBomLineUI from "@models/IBomLineUI";
import IComponentShortage from "@models/IComponentShortage";
import ProductGroupDetail from "./ProductGroupDetail/ProductGroupDetail";
import ProductGroupPriceGroupAvailability from "./ProductGroupPriceGroupAvailability/ProductGroupPriceGroupAvailability";
import { MultiProductGroupDetail } from "./MultiProductGroupDetail/MultiProductGroupDetail";
import IGroupSubsection from "@models/IGroupSubsection";
import IGroupSubsectionUI from "@models/IGroupSubsectionUI";
import { v4 } from "uuid";
import ProductSourcesDetail from "./ProductSourcesDetail/ProductSourcesDetail";
import VendorSourcesDetail from "./VendorSourcesDetail/VendorSourcesDetail";
import WarehouseDetail from "./WarehouseDetail/WarehouseDetail";
import AutomationDetail from "./AutomationDetail/AutomationDetail";
import IAutomation from "@models/IAutomation";
import { CatalogItemChildItemDetail } from "../CatalogItemChildItemDetail/CatalogItemChildItemDetail";
import ICatalog_Item_Child_Item_MapUI from "@models/ICatalog_Item_Child_Item_MapUI";
import { OwFnInput } from "@components/shared/OwFnInput/OwFnInput";
import { Socket } from "socket.io-client";
import IDiscount from "@models/IDiscount";
import { DiscountAssignment } from "@components/shared/DiscountAssignment/DiscountAssignment";
import { UomSetCatalogItem } from "./UomSetCatalogItem/UomSetCatalogItem";
import IUnit_Of_Measurement_Set from "@models/IUnit_Of_Measurement_Set";
import { FilesDownloadSection } from "@components/shared/FilesDownloadSection/FilesDownloadSection";
import IQBOItemDTO from "@models/QuickBooks Online/IQBOItemDTO";
import IUiSocketSetup from "@models/IUiSocketSetup";
import { CatalogItemSidebarQbdSection } from "./CatalogItemSidebarQbdSection/CatalogItemSidebarQbdSection";
import { CatalogItemSidebarQboSection } from "./CatalogItemSidebarQboSection/CatalogItemSidebarQboSection";
import { CatalogItemKitBuilder } from "./CatalogItemKitBuilder/CatalogItemKitBuilder";
import IKit_Builder_OptionUI from "@models/IKit_Builder_OptionUI";
import { CatalogItemSidebarPriceGroupInputs } from "./CatalogItemSidebarPriceGroupInputs/CatalogItemSidebarPriceGroupInputs";
import { CatalogItemPriceBandBuilder } from "./CatalogItemPriceBandBuilder/CatalogItemPriceBandBuilder";
import IPrice_Bands_Structured from "@models/IPrice_Bands_Structured";
import ICatalog from "@models/ICatalog";
import IPrice_Band_Compiled from "@models/IPrice_Band_Compiled";
import INewCatalog_Item_Option from "@models/INewCatalog_Item_Option";
import ICatalog_Item_Option from "@models/ICatalog_Item_Option";
import { CatalogItemSidebarItemOptionSection } from "./CatalogItemSidebarItemOptionSection/CatalogItemSidebarItemOptionSection";
import OwToggle from "@components/shared/OwToggle/OwToggle";
import { ClickToCopy } from "@components/shared/ClickToCopy/ClickToCopy";
import { IPricing_Formula } from "@models/IPricing_Formula";
import IGetPricingFormulasDTO from "@models/DTO/IGetPricingFormulasDTO";
import IOnGetPricingFormulasDTO from "@models/DTO/IOnGetPricingFormulasDTO";
import { TypeaheadFn } from "@components/shared/TypeaheadFn/TypeaheadFn";
import IOnGetPriceGroupsDTO from "@models/DTO/IOnGetPriceGroupsDTO";
import IGetPriceGroupsDTO from "@models/DTO/IGetPriceGroupsDTO";
import { OwIconTooltip } from "@components/shared/OwIconTooltip/OwIconTooltip";
import ICatalogItemSkuLookupResult from "@models/ICatalogItemSkuLookupResult";

type Props = {
    catalogModel: ICatalog;
    catalogGuid: string;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    catalog_item?: ICatalog_ItemUI;
    cancel: (refreshData?: boolean, item?: ICatalog_Item) => void;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    priceGroups?: IPrice_Group[];
    vendorSources?: IVendor_Source[];
    showHiddenFeatures: boolean;
    getPriceGroups?: boolean;
};

type State = {
    hasLoaded: boolean;
    createAnother?: boolean;
    name?: string;
    sku?: string;
    manufacturer?: string;
    upc?: string;
    ean?: string;
    skuTitle?: string;
    short_description?: string;
    description?: string;
    purchase_link?: string | null;
    color?: string;
    style?: string;
    pricing?: any;
    /** True once the user changed pricing in this sidebar session; later detail responses then no longer replace it. */
    pricing_dirty: boolean;
    pricing_descriptions?: any;
    msrp?: number;
    map?: number;
    cost_per_uom?: number;
    packs?: number;
    unit_of_measurement_id?: any;
    dimension_unit_id?: any;
    active?: boolean;
    has_inventory?: boolean;
    row?: string;
    bin?: string;
    has_serials?: boolean;
    is_nfa?: boolean;
    bypass_production_workflow?: boolean;
    qty_on_hand?: number;
    qty_incoming?: number;
    max_order_qty?: number;
    min_order_qty?: number;
    min_qty_on_hand?: number;
    max_qty_on_hand?: number;
    reserved_qty_on_hand?: number;
    width?: number;
    user_entered_width?: boolean;
    height?: number;
    user_entered_height?: boolean;
    depth?: number;
    user_entered_depth?: boolean;
    case_width?: number;
    case_height?: number;
    case_depth?: number;
    case_dimension_unit_id?: any;
    case_weight?: number;
    case_weight_unit_id?: any;
    item_weight?: number;
    item_weight_unit_id?: any;
    shipping_weight?: number;
    shipping_weight_unit_id?: any;
    catalog_item?: ICatalog_ItemUI;
    activeSaveCatalogItem?: boolean;
    disableSaveCatalogItem?: boolean;
    existingCatalogItem?: boolean;
    create_in_qbo?: boolean;
    create_in_qbd?: boolean;
    createItemInQuickBooksOnline?: boolean;
    showColorStyleInput: boolean;
    is_common_item?: boolean;
    is_product_group?: boolean;
    product_group_type?: "flat" | "multi" | null;
    product_group_display_style?: "ALL_VISIBLE" | "SELECT_SECTION" | null;
    group_parent_catalog_item_id?: number | null;
    original_group_parent_catalog_item_id?: number | null;
    category_id?: number | null;
    group_items?: IGroupItem[];
    multi_group_items: IGroupSubsectionUI[];
    third_party_sku?: string;
    third_party_pricing?: string;
    third_party_size?: string;
    qbd_IncomeAccountListID?: string;
    qbd_AssetAccountListID?: string;
    qbd_COGSAccountListID?: string;
    qbd_ListId?: string;
    qbd_skip_sending?: boolean | null;
    qbd_skip_updating?: boolean | null;
    formValid: boolean;
    materials: IMaterial[];
    materialsQtySet: { material: IMaterial; qty: number }[];
    refreshData: boolean;
    require_addl_input?: boolean;
    addl_input_description?: string;
    has_sources?: boolean;
    has_alternate_sourcing?: boolean;
    is_alternate_source?: boolean;
    is_customer_orderable?: boolean;
    productSources?: ICatalog_Item[];
    vendorSources?: IVendorSourceItem[];
    warehouseMap?: IWarehouseItem[];
    selectedVendorSource?: IVendor_Source | null;
    selectedVendorSourceLocation?: IVendor_Source_Location | null;
    selectedVendorSourceLocations: IVendor_Source_LocationUI[];
    hasPendingLocationChanges: boolean;
    taxjar_category_id?: number | null;
    taxJarCategories: ITaxJar_Category[];
    selectedTaxJarCategory?: ITaxJar_Category;
    price_list_date?: Date;
    unit_incr_qty?: number;
    has_pack_qty?: boolean;
    pack_qty?: number;
    // If the price is each individual item, or is per pack.
    price_per_pack?: boolean;
    is_kit: boolean;
    sum_to_single_invoice_item: boolean;
    is_kit_builder?: boolean | null;
    is_advanced_kit: boolean;
    has_kit_base_options: boolean;
    qbo_bundle_each_option_own_line_item: boolean;
    kit_add_each_item: boolean;
    kit_item_option_addl_charge: boolean;
    kit_items: IKit_Catalog_Items_MapUI[];
    updated_kit_items: (IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[];
    /** Bill of materials lines (OR-1457) as edited; sent as bom_lines once the item has loaded. */
    bom_lines: IBomLineUI[];
    /** True once a detail response actually carried Bom_Lines (missing ≠ empty: a missing field must never wipe lines). */
    bom_lines_loaded: boolean;
    /** True once the user changed the BOM in this sidebar session. */
    bom_lines_dirty: boolean;
    updated_kit_builder_options: (IKit_Builder_OptionUI | Partial<IKit_Builder_OptionUI>)[];
    kit_builder_base_items: (IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[];
    updated_kit_builder_base_items: (IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[];
    showKitBuilderConversionModal: boolean;
    qty_break?: number;
    qty_break_price?: number;
    exclude_bonus_qty?: boolean;
    item_order?: string;
    automations: IAutomation[];
    wayfair_item: boolean | null;
    is_taxable: boolean;
    is_new_release: boolean;
    is_ready_to_ship: boolean;
    allow_backorder: boolean;
    backorder_limit: number;
    skip_discount: boolean;
    delivery_eta?: Moment;
    child_items?: ICatalog_Item_Child_Item_MapUI[];
    defaultVendorSourceId?: number | null;
    min_price?: number | null;
    manual_serial_entry?: boolean | null;
    max_serials_per_order_item?: number | null;
    discounts: number[];
    base_unit_id?: number | null;
    purchasing_base_unit_id?: number | null;
    is_ordered_on_demand?: boolean;
    /** BOM component (OR-1457): hidden from sales pickers and the portal by default. */
    is_component?: boolean;
    is_catch_weight?: boolean;
    foundQboItems?: IQBOItemDTO[];
    manual_qbo_item?: IQBOItemDTO;
    has_price_bands: boolean;
    priceBands: IPrice_Bands_Structured;
    itemOptionValues?: (INewCatalog_Item_Option | ICatalog_Item_Option)[];
    selectedItemOptions?: ICatalog_Item_Option[];
    pricing_formula_id?: number | null;
    pricingFormulas: IPricing_Formula[];
    selectedPricingFormula?: IPricing_Formula;
    qbo_skip_updating?: boolean;
    qbo_skip_sending?: boolean;
    priceGroups: IPrice_Group[];
    qbo_as_description_line?: boolean;
    catalogItemAttributes?: ICatalog_Item_Attribute[];
    skuLookupStatus?: "checking" | "available" | "duplicate";
    skuLookupMatches?: ICatalogItemSkuLookupResult[];
};

class CreateCatalogItemSidebar extends Component<Props, State> {
    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        let materialsQtySet: { material: IMaterial; qty: number }[] = [];
        let materials: IMaterial[] = [];

        if (this.props.supplierModel.has_bom && this.props.catalog_item?.Material_Catalog_Item_Maps) {
            materialsQtySet = this.props.catalog_item?.Material_Catalog_Item_Maps.map((materialMap) => {
                return {
                    material: materialMap.Material!,
                    qty: materialMap.qty,
                };
            });

            materials = this.props.catalog_item.Material_Catalog_Item_Maps.map((materialMap) => {
                return materialMap.Material!;
            });
        }

        // let warehouseMap: IWarehouseItem[] = [];

        let price_list_date: Date | undefined;

        if (this.props.catalog_item?.price_list_date) {
            price_list_date = moment(this.props.catalog_item.price_list_date).toDate();
        }

        let min_order_qty = _.get(this.props.catalog_item, "min_order_qty", 0);
        let max_order_qty = _.get(this.props.catalog_item, "max_order_qty", 0);

        if (_.isNil(min_order_qty)) {
            min_order_qty = 0;
        } else {
            min_order_qty = Number(min_order_qty || 0);
        }

        if (_.isNil(max_order_qty)) {
            max_order_qty = 0;
        } else {
            max_order_qty = Number(max_order_qty || 0);
        }

        let delivery_eta: Moment | undefined;

        if (this.props.supplierModel.has_catalog_item_delivery_eta) {
            if (this.props.catalog_item?.delivery_eta) {
                delivery_eta = moment(this.props.catalog_item.delivery_eta);
            }
        }

        let allow_backorder: boolean = this.props.catalog_item?.allow_backorder || false;

        if (!this.props.catalog_item?.guid) {
            allow_backorder = this.props.supplierModel.default_allow_backorders || false;
        }

        const pricing = _.get(this.props.catalog_item, "pricing", {});

        if (pricing) {
            if (this.props.priceGroups) {
                for (const priceGroup of this.props.priceGroups) {
                    // make sure the current pricing is setup at least with 0s.
                    if (!pricing[`${priceGroup.value}`]) {
                        pricing[`${priceGroup.value}`] = 0;
                    }
                }
            }
        }

        this.state = {
            hasLoaded: false,
            createAnother: false,
            catalog_item: this.props.catalog_item,
            activeSaveCatalogItem: false,
            disableSaveCatalogItem: false,
            create_in_qbo: true,
            create_in_qbd: true,
            name: _.get(this.props.catalog_item, "name", ""),
            sku: _.get(this.props.catalog_item, "sku", ""),
            manufacturer: _.get(this.props.catalog_item, "manufacturer") || "",
            upc: _.get(this.props.catalog_item, "upc", ""),
            ean: _.get(this.props.catalog_item, "ean", ""),
            short_description: _.get(this.props.catalog_item, "short_description", ""),
            description: _.get(this.props.catalog_item, "description", ""),
            purchase_link: _.get(this.props.catalog_item, "purchase_link", ""),
            color: _.get(this.props.catalog_item, "color", ""),
            style: _.get(this.props.catalog_item, "style", ""),
            pricing,
            pricing_descriptions: _.get(this.props.catalog_item, "pricing_descriptions", {}),
            msrp: _.get(this.props.catalog_item, "msrp"),
            map: _.get(this.props.catalog_item, "map"),
            cost_per_uom: _.get(this.props.catalog_item, "cost_per_uom"),
            packs: _.get(this.props.catalog_item, "packs"),
            unit_of_measurement_id: _.get(this.props.catalog_item, "unit_of_measurement_id", ""),
            dimension_unit_id: _.get(this.props.catalog_item, "dimension_unit_id", ""),
            allow_backorder: _.get(this.props.catalog_item, "allow_backorder", allow_backorder),
            backorder_limit: this.props.catalog_item?.backorder_limit || 0,
            // active: _.get(this.props.catalog_item, "active", true),
            width: Number(_.get(this.props.catalog_item, "width", "")),
            height: Number(_.get(this.props.catalog_item, "height", "")),
            depth: Number(_.get(this.props.catalog_item, "depth", "")),
            case_width: Number(_.get(this.props.catalog_item, "case_width", "")),
            case_height: Number(_.get(this.props.catalog_item, "case_height", "")),
            case_depth: Number(_.get(this.props.catalog_item, "case_depth", "")),
            case_dimension_unit_id: _.get(this.props.catalog_item, "case_dimension_unit_id", undefined),
            case_weight: Number(_.get(this.props.catalog_item, "case_weight", "")),
            case_weight_unit_id: _.get(this.props.catalog_item, "case_weight_unit_id", undefined),
            item_weight: Number(_.get(this.props.catalog_item, "item_weight", "")),
            item_weight_unit_id: _.get(this.props.catalog_item, "item_weight_unit_id", undefined),
            shipping_weight: Number(_.get(this.props.catalog_item, "shipping_weight", "")),
            shipping_weight_unit_id: _.get(this.props.catalog_item, "shipping_weight_unit_id", undefined),
            has_inventory: _.get(this.props.catalog_item, "has_inventory", false),
            row: _.get(this.props.catalog_item, "row", ""),
            bin: _.get(this.props.catalog_item, "bin", ""),
            has_sources: _.get(this.props.catalog_item, "has_sources", false),
            has_alternate_sourcing: _.get(this.props.catalog_item, "has_alternate_sourcing", false),
            is_alternate_source: _.get(this.props.catalog_item, "is_alternate_source", false),
            is_customer_orderable: _.get(this.props.catalog_item, "is_customer_orderable", false),
            has_serials: _.get(this.props.catalog_item, "has_serials", false),
            is_nfa: _.get(this.props.catalog_item, "is_nfa", false),
            bypass_production_workflow: _.get(this.props.catalog_item, "bypass_production_workflow", false),
            showColorStyleInput: false,
            is_common_item: _.get(this.props.catalog_item, "is_common_item", false),
            is_product_group: _.get(this.props.catalog_item, "is_product_group", false),
            product_group_type: _.get(this.props.catalog_item, "product_group_type", null) as "flat" | "multi" | null,
            product_group_display_style: _.get(this.props.catalog_item, "product_group_display_style", null) as
                | "ALL_VISIBLE"
                | "SELECT_SECTION"
                | null,
            group_parent_catalog_item_id: _.get(this.props.catalog_item, "group_parent_catalog_item_id") || undefined,
            original_group_parent_catalog_item_id: _.get(this.props.catalog_item, "group_parent_catalog_item_id") || undefined,
            group_items: _.get(this.props.catalog_item, "group_items", []) as any, // TODO Issue??
            multi_group_items: (_.get(this.props.catalog_item, "multi_group_items", []) as IGroupSubsection[]).map((s) => ({
                ...s,
                uuid: v4(),
                items: (s.items ?? []).map((l) => ({ ...l, uuid: v4() })),
            })),
            third_party_pricing: _.get(this.props.catalog_item, "third_party_pricing") || "",
            third_party_sku: _.get(this.props.catalog_item, "third_party_sku") || "",
            third_party_size: _.get(this.props.catalog_item, "third_party_size") || "",
            require_addl_input: _.get(this.props.catalog_item, "require_addl_input", false),
            addl_input_description: _.get(this.props.catalog_item, "addl_input_description", ""),
            reserved_qty_on_hand: _.get(this.props.catalog_item, "reserved_qty_on_hand", 0),
            taxjar_category_id: _.get(this.props.catalog_item, "taxjar_category_id", undefined),
            qbd_ListId: _.get(this.props.catalog_item, "qbd_ListId", undefined),
            min_order_qty,
            max_order_qty,
            unit_incr_qty: _.get(this.props.catalog_item, "unit_incr_qty", 1),
            has_pack_qty: _.get(this.props.catalog_item, "has_pack_qty", undefined),
            price_per_pack: _.get(this.props.catalog_item, "price_per_pack", undefined),
            pack_qty: _.get(this.props.catalog_item, "pack_qty", 0),
            qty_break: _.get(this.props.catalog_item, "qty_break", 0),
            qty_break_price: _.get(this.props.catalog_item, "qty_break_price", 0),
            min_price: _.get(this.props.catalog_item, "min_price", 0),
            formValid: false,
            materials,
            materialsQtySet,
            refreshData: false,
            selectedVendorSourceLocation: null,
            selectedVendorSource: null,
            hasPendingLocationChanges: false,
            selectedVendorSourceLocations: [],
            taxJarCategories: [],
            price_list_date,
            is_kit: _.get(this.props.catalog_item, "is_kit", false),
            is_kit_builder: _.get(this.props.catalog_item, "is_kit_builder", false),
            is_advanced_kit: _.get(this.props.catalog_item, "is_advanced_kit", false),
            has_kit_base_options: _.get(this.props.catalog_item, "has_kit_base_options", false),
            qbo_bundle_each_option_own_line_item: _.get(this.props.catalog_item, "qbo_bundle_each_option_own_line_item", false),
            kit_add_each_item: _.get(this.props.catalog_item, "kit_add_each_item", false),
            kit_item_option_addl_charge: _.get(this.props.catalog_item, "kit_item_option_addl_charge", false),
            kit_items: _.get(this.props.catalog_item, "Kit_Items_Map", []),
            updated_kit_items: _.get(this.props.catalog_item, "Kit_Items_Map", []),
            bom_lines: CreateCatalogItemSidebar.bomLinesFromItem(this.props.catalog_item),
            bom_lines_loaded: Array.isArray(this.props.catalog_item?.Bom_Lines),
            bom_lines_dirty: false,
            pricing_dirty: false,
            updated_kit_builder_options: _.get(this.props.catalog_item, "Kit_Builder_Options", []),
            kit_builder_base_items: _.get(this.props.catalog_item, "is_kit_builder", false)
                ? _.get(this.props.catalog_item, "Kit_Items_Map", [])
                : _.get(this.props.catalog_item, "Kit_Items_Map", []).filter(
                      (item: IKit_Catalog_Items_MapUI) => item.is_kit_base_option === true
                  ),
            updated_kit_builder_base_items: _.get(this.props.catalog_item, "is_kit_builder", false)
                ? _.get(this.props.catalog_item, "Kit_Items_Map", [])
                : _.get(this.props.catalog_item, "Kit_Items_Map", []).filter(
                      (item: IKit_Catalog_Items_MapUI) => item.is_kit_base_option === true
                  ),
            showKitBuilderConversionModal: false,
            exclude_bonus_qty: _.get(this.props.catalog_item, "exclude_bonus_qty", false),
            item_order: _.get(this.props.catalog_item, "item_order", ""),
            automations: _.get(this.props.catalog_item, "Automations", []),
            wayfair_item: _.get(this.props.catalog_item, "wayfair_item", false),
            is_taxable: _.get(this.props.catalog_item, "is_taxable", false),
            is_new_release: _.get(this.props.catalog_item, "is_new_release", false),
            is_ready_to_ship: _.get(this.props.catalog_item, "is_ready_to_ship", false),
            skip_discount: _.get(this.props.catalog_item, "skip_discount", false),
            manual_serial_entry: _.get(this.props.catalog_item, "manual_serial_entry", false),
            max_serials_per_order_item: _.get(this.props.catalog_item, "max_serials_per_order_item", null),
            delivery_eta,
            discounts: [],
            base_unit_id: _.get(this.props.catalog_item, "base_unit_id", undefined),
            is_ordered_on_demand: _.get(this.props.catalog_item, "is_ordered_on_demand", false) || false,
            is_component: _.get(this.props.catalog_item, "is_component", false) || false,
            is_catch_weight: _.get(this.props.catalog_item, "is_catch_weight", false) || false,
            sum_to_single_invoice_item: _.get(this.props.catalog_item, "sum_to_single_invoice_item", false) || false,
            qbd_skip_sending: _.get(this.props.catalog_item, "qbd_skip_sending", false) || false,
            qbd_skip_updating: _.get(this.props.catalog_item, "qbd_skip_updating", false) || false,
            foundQboItems: [],
            has_price_bands: _.get(this.props.catalog_item, "has_price_bands", false) || false,
            priceBands: _.get(this.props.catalog_item, "Price_Bands", {}) || {},
            defaultVendorSourceId: _.get(this.props.catalog_item, "default_vendor_source_id", null),
            itemOptionValues: [],
            selectedItemOptions: [],
            pricing_formula_id: _.get(this.props.catalog_item, "pricing_formula_id", null),
            pricingFormulas: [],
            selectedPricingFormula: this.props.catalog_item?.Pricing_Formula || undefined,
            qbo_skip_updating: _.get(this.props.catalog_item, "qbo_skip_updating", false) || false,
            qbo_skip_sending: _.get(this.props.catalog_item, "qbo_skip_sending", false) || false,
            priceGroups: this.props.priceGroups || [],
            qbo_as_description_line: _.get(this.props.catalog_item, "qbo_as_description_line", false) || false,
        };

        // console.log("Constructor: ", _.get(this.props.catalog_item, "Price_Bands", {}) || {}, this.props.catalog_item?.Price_Bands);

        this.sockets = [
            { endpoint: EndpointsEnum.CatalogItemOnCreateCatalogItem, fn: this.onCreateCatalogItem },
            { endpoint: EndpointsEnum.CatalogItemOnUpdateCatalogItem, fn: this.onUpdateCatalogItem },
            { endpoint: EndpointsEnum.CatalogItemOnGetCatalogItem, fn: this.onGetCatalogItem },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.FileUploadOnDeleteFileUpload, fn: this.onDeleteFileUpload },
            { endpoint: EndpointsEnum.FileUploadOnCreateFileUpload, fn: this.onCreateFileUpload },
            { endpoint: EndpointsEnum.TaxJarOnGetTaxCategories, fn: this.onGetTaxJarCategories },
            { endpoint: EndpointsEnum.CatalogsOnGetPricingFormulas, fn: this.onGetPricingFormulas },
            { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
        ];
    }

    processLocations = (categoryLocations: IVendor_Source_Location[]): IVendor_Source_Location_Map_Item[] => {
        const locations: IVendor_Source_Location_Map_Item[] = [];

        for (const location of categoryLocations) {
            const locationDetail: IVendor_Source_Location_Map_Item = {
                vendor_source_id: location.vendor_source_id,
                vendor_source_location_id: location.id,
            };

            locations.push(locationDetail);
        }

        return locations;
    };

    propsToState = (catalogItem: any, props: any) => {
        const processedCatalogItem: any = {};

        _.each(props, (propName) => {
            let value = _.get(catalogItem, `${propName}`, "");

            if (_.isNil(value)) {
                value = "";
            }

            processedCatalogItem[propName] = value;
        });

        return processedCatalogItem;
    };

    componentDidMount() {
        const catalog_item = this.props.catalog_item;

        const propsArr = [
            "name",
            "sku",
            "description",
            "pricing",
            "unit_of_measurement_id",
            "dimension_unit_id",
            "allow_backorder",
            "width",
            "height",
            "depth",
            "item_weight",
            "shipping_weight",
            "case_weight",
            "active",
            "qty_on_hand",
            "qty_incoming",
            "reserved_qty_on_hand",
            "min_qty_on_hand",
            "max_qty_on_hand",
            "is_common_item",
            "is_product_group",
            "third_party_pricing",
            "third_party_sku",
            "third_party_size",
            "min_order_qty",
            "max_order_qty",
        ];

        const processedCatalogItem = this.propsToState(catalog_item, propsArr);

        let active = _.get(processedCatalogItem, "active", true);

        if (_.isNil(active) || (_.isString(active) && !active.length)) {
            active = true;
        }

        let existingCatalogItem = false;

        if (!_.isNil(this.props.catalog_item) && this.props.catalog_item.guid) {
            existingCatalogItem = true;
        }

        const qty_on_hand = _.get(this.props.catalog_item, "qty_on_hand", null);
        const min_qty_on_hand = _.get(this.props.catalog_item, "min_qty_on_hand", null);
        const max_qty_on_hand = _.get(this.props.catalog_item, "max_qty_on_hand", null);
        const qty_incoming = _.get(this.props.catalog_item, "qty_incoming", null);
        let min_order_qty = _.get(this.props.catalog_item, "min_order_qty", 0);
        let max_order_qty = _.get(this.props.catalog_item, "max_order_qty", 0);
        let qty_break = _.get(this.props.catalog_item, "qty_break", 0);
        let qty_break_price = _.get(this.props.catalog_item, "qty_break_price", 0);

        if (_.isNil(min_order_qty)) {
            min_order_qty = 0;
        }

        if (_.isNil(max_order_qty)) {
            max_order_qty = 0;
        }

        if (_.isNil(qty_on_hand)) {
            // qty_on_hand = "";
        }

        if (_.isNil(min_qty_on_hand)) {
            // min_qty_on_hand = "";
        }

        if (_.isNil(qty_break)) {
            qty_break = 0;
        }

        if (_.isNil(qty_break_price)) {
            qty_break_price = 0;
        }

        // qty_on_hand = qty_on_hand.toString();
        // min_qty_on_hand = min_qty_on_hand.toString();
        let showColorStyleInput = this.state.showColorStyleInput;

        if (this.props.supplierModel.has_style_color) {
            showColorStyleInput = true;
        }

        let skuTitle: string | undefined;

        if (this.state.is_product_group) {
            skuTitle = this.getSkuTitle(this.state.is_product_group);
        }

        const formValid = this.isFormValid(this.state.name, this.state.sku, this.state.skuLookupStatus);

        const state: any = {
            qty_on_hand,
            qty_incoming,
            min_qty_on_hand,
            max_qty_on_hand,
            min_order_qty,
            max_order_qty,
            existingCatalogItem,
            active,
            showColorStyleInput,
            skuTitle,
            formValid,
            qty_break,
            qty_break_price,
        };

        this.setState(state);

        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        // Because of the Number of nested categories a user could have, we don't
        // have the full category hierarchy for a catalog item and need to
        // retrieve it again to make sure it's filled out.
        // if (this.props.catalog_item && this.props.catalog_item.category_id) {
        if (this.props.catalog_item?.id) {
            this.getCatalogItem();
        }

        if (this.props.getPriceGroups) {
            this.getPriceGroups();
        }
        // }
    }

    componentWillUnmount() {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    notify = (data: IErrorDTO) => {
        this.setState({
            activeSaveCatalogItem: false,
            disableSaveCatalogItem: false,
        });
    };

    createCatalogItem = () => {
        // TODO Swap out the pricing 'price group' for one setup by the user.

        // let priceGroups = Object.keys(this.state.pricing);
        // let priceGroupsLength = priceGroups.length;

        // console.log("pricing", this.state.pricing);

        let allow_backorder = this.state.allow_backorder;

        if (_.isNil(allow_backorder) || _.isString(allow_backorder)) {
            allow_backorder = false;
        }

        let has_serials = this.state.has_serials;

        if (_.isNil(has_serials) || _.isString(has_serials)) {
            has_serials = false;
        }

        let has_inventory = this.state.has_inventory;

        if (_.isNil(has_inventory) || _.isString(has_inventory)) {
            has_inventory = false;
        }

        let has_sources = this.state.has_sources;

        if (_.isNil(has_sources) || _.isString(has_sources)) {
            has_sources = false;
        }

        let has_alternate_sourcing = this.state.has_alternate_sourcing;

        if (_.isNil(has_alternate_sourcing) || _.isString(has_alternate_sourcing)) {
            has_alternate_sourcing = false;
        }

        let is_alternate_source = this.state.is_alternate_source;

        if (_.isNil(is_alternate_source) || _.isString(is_alternate_source)) {
            is_alternate_source = false;
        }

        let is_customer_orderable = this.state.is_customer_orderable;

        if (_.isNil(is_customer_orderable) || _.isString(is_customer_orderable)) {
            is_customer_orderable = false;
        }

        const payload: any = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            catalogGuid: this.props.catalogGuid,
            supplierGuid: this.props.supplierModel.guid,
            name: this.state.name,
            sku: this.state.sku,
            manufacturer: this.state.manufacturer,
            upc: this.state.upc,
            ean: this.state.ean,
            short_description: this.state.short_description,
            description: this.state.description,
            pricing: this.state.pricing,
            pricing_descriptions: this.state.pricing_descriptions,
            msrp: this.state.msrp,
            map: this.state.map,
            cost_per_uom: this.state.cost_per_uom,
            packs: this.state.packs,
            dimension_unit_id: this.props.supplierModel.has_dimensions ? this.state.dimension_unit_id : undefined,
            unit_of_measurement_id: this.state.unit_of_measurement_id,
            width: this.props.supplierModel.has_dimensions ? this.state.width : undefined,
            height: this.props.supplierModel.has_dimensions ? this.state.height : undefined,
            depth: this.props.supplierModel.has_dimensions ? this.state.depth : undefined,
            case_width: this.props.supplierModel.has_dimensions ? this.state.case_width : undefined,
            case_height: this.props.supplierModel.has_dimensions ? this.state.case_height : undefined,
            case_depth: this.props.supplierModel.has_dimensions ? this.state.case_depth : undefined,
            case_dimension_unit_id: this.props.supplierModel.has_dimensions ? this.state.case_dimension_unit_id : undefined,
            case_weight: this.state.case_weight,
            case_weight_unit_id: this.state.case_weight_unit_id,
            item_weight: this.state.item_weight,
            item_weight_unit_id: this.state.item_weight_unit_id,
            shipping_weight: this.state.shipping_weight,
            shipping_weight_unit_id: this.state.shipping_weight_unit_id,
            allow_backorder,
            active: this.state.active,
            qty_on_hand: this.state.qty_on_hand,
            qty_incoming: this.state.qty_incoming,
            min_order_qty: this.state.min_order_qty,
            max_order_qty: this.state.max_order_qty,
            min_qty_on_hand: !_.isNil(this.state.min_qty_on_hand) ? this.state.min_qty_on_hand : null,
            max_qty_on_hand: !_.isNil(this.state.max_qty_on_hand) ? this.state.max_qty_on_hand : null,
            create_in_qbo: this.state.create_in_qbo,
            create_in_qbd: this.state.create_in_qbd,
            has_inventory,
            has_sources,
            has_serials,
            color: this.state.color,
            style: this.state.style,
            is_common_item: this.state.is_common_item,
            category_id: this.state.category_id,
            is_product_group: this.state.is_product_group,
            group_parent_catalog_item_id: this.state.group_parent_catalog_item_id ?? null,
            product_group_type: this.state.is_product_group ? (this.state.product_group_type ?? "flat") : undefined,
            product_group_display_style:
                this.state.is_product_group && this.state.product_group_type === "multi"
                    ? (this.state.product_group_display_style ?? "ALL_VISIBLE")
                    : undefined,
            group_items: this.state.is_product_group && this.state.product_group_type !== "multi" ? this.state.group_items : undefined,
            multi_group_items:
                this.state.is_product_group && this.state.product_group_type === "multi"
                    ? this.state.multi_group_items
                          .filter((s) => s.id || !s.deleteFlag) // drop session-only sections marked deleted
                          .map((s, i) => ({
                              id: s.id,
                              guid: s.guid,
                              catalog_item_id: s.catalog_item_id,
                              title: s.title,
                              sequence: i,
                              deleteFlag: s.deleteFlag,
                              items: s.items
                                  .filter((l) => l.id || !l.deleteFlag) // drop session-only leaves marked deleted
                                  .map((l, j) => ({
                                      id: l.id,
                                      guid: l.guid,
                                      catalog_item_id: l.catalog_item_id,
                                      group_sequence: j,
                                      group_title: l.group_title,
                                      deleteFlag: l.deleteFlag,
                                  })),
                          }))
                    : undefined,
            third_party_sku: this.state.third_party_sku,
            third_party_pricing: this.state.third_party_pricing,
            third_party_size: this.state.third_party_size,
            qbd_IncomeAccountListID: this.state.qbd_IncomeAccountListID,
            qbd_AssetAccountListID: this.state.qbd_AssetAccountListID,
            qbd_COGSAccountListID: this.state.qbd_COGSAccountListID,
            require_addl_input: this.state.require_addl_input,
            addl_input_description: this.state.addl_input_description,
            is_customer_orderable,
            has_alternate_sourcing,
            is_alternate_source,
            taxjar_category_id: this.state.taxjar_category_id,
            pricing_formula_id: this.state.pricing_formula_id,
            unit_incr_qty: this.state.unit_incr_qty,
            has_pack_qty: this.state.has_pack_qty,
            price_per_pack: this.state.price_per_pack,
            pack_qty: this.state.pack_qty,
            is_kit: this.state.is_kit,
            is_advanced_kit: this.state.is_advanced_kit,
            is_kit_builder: this.state.is_kit_builder,
            has_kit_base_options: this.state.has_kit_base_options,
            qbo_bundle_each_option_own_line_item: this.state.qbo_bundle_each_option_own_line_item,
            kit_add_each_item: this.state.kit_add_each_item,
            kit_item_option_addl_charge: this.state.kit_item_option_addl_charge,
            kit_items: this.state.is_kit_builder
                ? this.state.updated_kit_builder_base_items.map((item) => ({
                      ...item,
                      is_kit_base_option: true,
                  }))
                : this.state.updated_kit_items,
            kit_builder_options: this.state.updated_kit_builder_options,
            item_order: this.state.item_order,
            automations: this.state.automations,
            is_taxable: this.state.is_taxable,
            skip_discount: this.state.skip_discount,
            row: this.state.row,
            bin: this.state.bin,
            manual_serial_entry: this.state.manual_serial_entry,
            max_serials_per_order_item: this.state.max_serials_per_order_item,
            is_nfa: this.state.is_nfa,
            bypass_production_workflow: has_serials ? this.state.bypass_production_workflow : false,
            backorder_limit: this.state.backorder_limit,
            purchase_link: this.state.purchase_link,
            is_ordered_on_demand: this.state.is_ordered_on_demand,
            is_component: this.state.is_component,
            is_catch_weight: this.state.is_catch_weight,
            sum_to_single_invoice_item: this.state.sum_to_single_invoice_item,
            qbd_skip_sending: this.state.qbd_skip_sending,
            qbd_skip_updating: this.state.qbd_skip_updating,
            has_price_bands: this.state.has_price_bands,
            price_bands: this.state.priceBands,
            item_options: this.state.itemOptionValues,
            user_entered_width: this.state.user_entered_width,
            attributes: this.state.catalogItemAttributes
                ?.filter((attr) => attr.value !== null && attr.value !== undefined)
                .map((attr) => ({
                    attribute_id: attr.attribute_id,
                    value: attr.value,
                    is_enabled: attr.is_enabled,
                })),
            user_entered_height: this.state.user_entered_height,
            user_entered_depth: this.state.user_entered_depth,
            qbo_as_description_line: this.state.qbo_as_description_line,
        };

        // if (this.state.priceBands) {
        //     let processedBands: any = {};
        //
        //     for (const key in Object.keys(this.state.priceBands)) {
        //         const band = this.state.priceBands[keys];
        //
        //         if (!processedBands[key]) {
        //             processedBands[key] = [];
        //         }
        //     }
        // }

        payload.default_vendor_source_id = this.state.defaultVendorSourceId;

        if (this.props.supplierModel.Supplier_Integration.has_wayfair) {
            payload.wayfair_item = this.state.wayfair_item;
        }

        if (this.props.supplierModel.has_uom_sets) {
            payload.base_unit_id = this.state.base_unit_id;
            payload.purchasing_base_unit_id = this.state.purchasing_base_unit_id;
        }

        if (this.props.supplierModel.has_order_bonus) {
            payload.exclude_bonus_qty = this.state.exclude_bonus_qty;
        }

        if (this.props.supplierModel.has_qty_break) {
            payload.qty_break = Number(this.state.qty_break || 0);
            payload.qty_break_price = Number(this.state.qty_break_price || 0);
        }

        if (payload.min_qty_on_hand && !payload.min_qty_on_hand.length) {
            payload.min_qty_on_hand = null;
        }

        if (this.props.supplierModel.has_new_releases_category) {
            payload.is_new_release = this.state.is_new_release;
        }

        if (this.props.supplierModel.has_ready_to_ship_category) {
            payload.is_ready_to_ship = this.state.is_ready_to_ship;
        }

        if (this.props.supplierModel.has_child_items) {
            payload.child_items = this.state.child_items || [];
        }

        if (this.props.supplierModel.has_discounts) {
            payload.discounts = this.state.discounts || [];
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            payload.qbo_skip_updating = this.state.qbo_skip_updating;
            payload.qbo_skip_sending = this.state.qbo_skip_sending;
        }

        if (this.props.supplierModel.has_bom) {
            // console.log("setup materials for payload");

            const materials: Partial<INew_Material_Catalog_Item_Map>[] = [];

            for (const materialQtySet of this.state.materialsQtySet) {
                materials.push({
                    material_id: materialQtySet.material.id,
                    qty: materialQtySet.qty,
                });
            }

            payload.materials = materials;
        }

        // Bill of materials (OR-1457). Send on create, or once a detail response carried Bom_Lines, or once
        // the user edited the BOM here. A save before the lines were loaded (or on a response without the
        // field) omits bom_lines, so it can never wipe the existing lines by accident.
        if (
            this.props.supplierModel.has_bom_v2 &&
            (!this.state.existingCatalogItem || this.state.bom_lines_loaded || this.state.bom_lines_dirty)
        ) {
            payload.bom_lines = this.state.bom_lines.map((line) => ({
                component_catalog_item_id: line.component_catalog_item_id,
                qty_per_unit: line.qty_per_unit,
            }));
        }

        // console.log("productSources", this.state.productSources);

        if (this.props.supplierModel.has_product_sources && this.state.has_alternate_sourcing && this.state.productSources) {
            payload.product_sources = this.state.productSources.map((productSource) => {
                return productSource.guid;
            });
        }

        if (this.props.supplierModel.has_purchase_orders && this.state.vendorSources) {
            payload.vendor_sources = this.state.vendorSources;
        }

        if (this.props.supplierModel.has_catalog_item_delivery_eta && this.state.delivery_eta) {
            payload.delivery_eta = this.state.delivery_eta.utc().format("YYYY-MM-DD hh:mm:ss");
        }

        if (this.props.supplierModel.has_purchase_orders && this.state.selectedVendorSourceLocations) {
            const vendorSourceLocations: IVendorSourceLocationItem[] = this.state.selectedVendorSourceLocations.map((location) => {
                const sourceItem: IVendorSourceLocationItem = {
                    vendor_source_location_id: location.id,
                    vendor_source_id: location.vendor_source_id,
                    deleteFlag: location.deleteFlag,
                };

                return sourceItem;
            });

            payload.vendor_source_locations = vendorSourceLocations;
        }

        if (this.props.supplierModel.has_warehouses && this.state.has_inventory) {
            payload.warehouse_map = this.state.warehouseMap;
        }

        if (this.props.supplierModel.below_min_price_approval) {
            payload.min_price = this.state.min_price;
        }

        if (this.state.manual_qbo_item) {
            payload.manual_qbo_item = this.state.manual_qbo_item;
        }

        if (!this.state.existingCatalogItem) {
            const createPayload: ICreateCatalogItemDTO = {
                ...payload,
            };

            this.props.socket.emit(EndpointsEnum.CatalogItemCreateCatalogItem, createPayload);
        } else {
            const updatePayload: IUpdateCatalogItemDTO = {
                ...payload,
                catalogItemGuid: this.props.catalog_item?.guid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogItemUpdateCatalogItem, updatePayload);
        }
    };

    onCreateCatalogItem = (data: IOnCreateCatalogItemDTO) => {
        const notification: INotification = {
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bl,
            title: "successfully_created_catalog_item",
        };

        this.props.notifyFn(null, notification, false);

        if (!this.state.createAnother) {
            this.props.cancel(true, data.catalog_item);
        } else {
            this.resetState();
        }
    };

    onUpdateCatalogItem = (data: IOnUpdateCatalogItemDTO) => {
        const notification: INotification = {
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
            title: "successfully_updated_catalog_item",
        };

        this.props.notifyFn(null, notification, false);

        this.props.cancel(true);
    };

    getPriceGroups = () => {
        const payload: IGetPriceGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogGuid: this.props.catalogGuid,
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
    };

    getCatalogItem = () => {
        if (this.state.catalog_item) {
            const payload = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogItemGuid: this.state.catalog_item.guid,
                catalogGuid: this.props.catalogGuid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogItemGetCatalogItem, payload);
        }
    };

    onGetCatalogItem = (data: IOnGetCatalogItemDTO) => {
        let productSources: ICatalog_Item[] = [];
        let vendorSources: IVendorSourceItem[] = [];

        // console.log("data.catalog_item", data.catalog_item);

        if (
            this.props.supplierModel.has_product_sources &&
            data.catalog_item &&
            data.catalog_item.has_alternate_sourcing &&
            data.catalog_item.Catalog_Item_Product_Source_Maps
        ) {
            // TODO set productSources Here
            productSources = data.catalog_item.Catalog_Item_Product_Source_Maps.map((sourceMap) => {
                return sourceMap.Source_Catalog_Item!;
            });

            // console.log("productSources", productSources);
        }

        if (this.props.supplierModel.has_purchase_orders && data.catalog_item.Catalog_Item_Vendor_Source_Maps) {
            vendorSources = data.catalog_item.Catalog_Item_Vendor_Source_Maps.map((source) => {
                return {
                    id: source.id,
                    vendor_source_id: source.vendor_source_id,
                    min_order_qty: source.min_order_qty,
                    unit_of_measurement_id: source.unit_of_measurement_id,
                    uom_qty_unit_of_measurement_id: source.uom_qty_unit_of_measurement_id,
                    uom_qty: source.uom_qty,
                    priority: source.priority,
                    Vendor_Source: source.Vendor_Source,
                    lead_time_type: source.lead_time_type,
                    lead_time: source.lead_time,
                    cost_price: source.cost_price,
                    manuf_part_no: source.manuf_part_no,
                } as IVendorSourceItem;
            });
        }

        let warehouseMap: IWarehouseItem[] = [];

        if (this.props.supplierModel.has_warehouses && data.catalog_item.Warehouse_Catalog_Items_Maps) {
            warehouseMap = data.catalog_item.Warehouse_Catalog_Items_Maps.map((itemMap: IWarehouse_Catalog_Items_Map) => {
                return {
                    warehouse_id: itemMap.warehouse_id,
                    bin: itemMap.bin,
                    row: itemMap.row,
                    qty_on_hand: itemMap.qty_on_hand,
                    Warehouse: itemMap.Warehouse,
                    id: itemMap.id,
                } as IWarehouseItem;
            });
        }

        let selectedTaxJarCategory: ITaxJar_Category | undefined;

        if (data.catalog_item.TaxJar_Category) {
            selectedTaxJarCategory = data.catalog_item.TaxJar_Category;
        }

        const kit_items = _.get(data.catalog_item, "Kit_Items_Map", []);

        // sort the vendor source locations.
        let vendorSourceLocations: IVendor_Source_Location[] = data.catalog_item.Vendor_Source_Locations || [];

        vendorSourceLocations = _.orderBy(vendorSourceLocations, (location: IVendor_Source_Location) => location.Vendor_Source!.name, [
            "asc",
        ]);

        let qty_on_hand = this.state.qty_on_hand;

        if (data.catalog_item.Material_Catalog_Item_Maps?.length) {
            qty_on_hand = CatalogItemService.getItemQtyOnHandBasedOnMaterials(data.catalog_item);
        }

        let kit_builder_base_items: IKit_Catalog_Items_MapUI[] = [];

        if (data.catalog_item.Kit_Items_Map?.length) {
            if (data.catalog_item.is_kit_builder) {
                // For Kit Builders, all Kit_Items_Map items are base items
                kit_builder_base_items = data.catalog_item.Kit_Items_Map;
            } else {
                // For regular advanced kits, filter by is_kit_base_option
                kit_builder_base_items = data.catalog_item.Kit_Items_Map.filter((item) => item.is_kit_base_option === true);
            }
        }

        const fetchedGroupParentId = _.get(data.catalog_item, "group_parent_catalog_item_id") || undefined;

        // Seed the BOM editor from the FIRST detail response that carries Bom_Lines, and never again: the
        // detail is re-fetched after image/file operations, and that must not discard unsaved BOM edits
        // (same idea as kit_items vs updated_kit_items). A response without Bom_Lines at all (older API)
        // leaves the editor untouched and does not count as loaded.
        const detailHasBomLines = Array.isArray(data.catalog_item.Bom_Lines);
        const keepEditorLines = this.state.bom_lines_loaded || this.state.bom_lines_dirty || !detailHasBomLines;
        const bom_lines = keepEditorLines ? this.state.bom_lines : CreateCatalogItemSidebar.bomLinesFromItem(data.catalog_item);
        const bom_lines_loaded = this.state.bom_lines_loaded || detailHasBomLines;

        // The item the sidebar opened with may carry pricing narrowed to one price group (order entry,
        // filtered lists); the detail response holds the full map. Take it unless pricing was edited here.
        const pricing = CatalogItemService.hydratePricing(
            this.state.pricing,
            data.catalog_item.pricing,
            this.state.priceGroups,
            this.state.pricing_dirty
        );

        this.setState(
            {
                hasLoaded: true,
                catalog_item: { ...(data.catalog_item as ICatalog_ItemUI), pricing },
                pricing,
                bom_lines,
                bom_lines_loaded,
                productSources,
                vendorSources,
                warehouseMap,
                kit_items,
                selectedVendorSourceLocations: vendorSourceLocations,
                selectedTaxJarCategory,
                qty_on_hand,
                automations: data.catalog_item.Automations || [],
                priceBands: _.get(data.catalog_item, "Price_Bands", {}) || {},
                selectedItemOptions: data.catalog_item?.Options || [],
                pricing_formula_id: data.catalog_item.pricing_formula_id || null,
                selectedPricingFormula: data.catalog_item.Pricing_Formula || undefined,
                catalogItemAttributes: data.catalog_item.Catalog_Item_Attributes || [],
                kit_builder_base_items,
                is_product_group: _.get(data.catalog_item, "is_product_group", false),
                product_group_type: _.get(data.catalog_item, "product_group_type", null) as "flat" | "multi" | null,
                product_group_display_style: _.get(data.catalog_item, "product_group_display_style", null) as
                    | "ALL_VISIBLE"
                    | "SELECT_SECTION"
                    | null,
                group_parent_catalog_item_id: fetchedGroupParentId,
                original_group_parent_catalog_item_id: fetchedGroupParentId,
                group_items: _.get(data.catalog_item, "group_items", []) as any,
                multi_group_items: (_.get(data.catalog_item, "multi_group_items", []) as IGroupSubsection[]).map((s) => ({
                    ...s,
                    uuid: v4(),
                    items: (s.items ?? []).map((l) => ({ ...l, uuid: v4() })),
                })),
                third_party_sku: _.get(data.catalog_item, "third_party_sku") || "",
            },
            () => {
                // Auto-generate a SKU from the name once the item has loaded, when enabled.
                this.maybeAutoGenerateSku();
            }
        );
    };

    deleteFileUpload = (attachmentGuid: string) => {
        const payload: IDeleteFileUploadDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            attachmentGuid,
        };

        this.props.socket.emit(EndpointsEnum.FileUploadDeleteFileUpload, payload);
    };

    onCreateFileUpload = (data: IOnCreateFileUploadDTO) => {
        this.setState(
            {
                refreshData: true,
            },
            () => {
                this.getCatalogItem();
            }
        );
    };

    onDeleteFileUpload = (data: IOnDeleteFileUploadDTO) => {
        this.setState(
            {
                refreshData: true,
            },
            () => {
                this.getCatalogItem();
            }
        );
    };

    resetState = (callbackFn?: any) => {
        const state: any = {
            name: "",
            sku: "",
            bom_lines: [],
            bom_lines_loaded: false,
            bom_lines_dirty: false,
            description: "",
            pricing: {},
            pricing_dirty: false,
            active: true,
            qty_on_hand: "0",
            qty_incoming: "0",
            allow_backorder: false,
            createItemInQuickBooksOnline: false,
            createAnother: false,
            activeSaveCatalogItem: false,
            disableSaveCatalogItem: false,
            is_product_group: false,
            bypass_production_workflow: false,
            is_component: false,
        };

        this.setState(state, () => {
            if (callbackFn) {
                callbackFn(true);
            }
            this.forceUpdate();
        });
    };

    cancel = (e: any) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        this.resetState(() => {
            this.props.cancel(this.state.refreshData);
        });
    };

    save = () => {
        // Never persist a SKU that's already in use elsewhere in the catalog.
        if (this.state.skuLookupStatus === "duplicate") {
            const notification: INotification = {
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
                title: "sku_already_in_use",
            };

            this.props.notifyFn(null, notification, false);
            return;
        }

        this.setState(
            {
                activeSaveCatalogItem: true,
                disableSaveCatalogItem: true,
            },
            () => {
                this.createCatalogItem();
            }
        );
    };

    handlePriceListDate = (dateMoment: Moment) => {
        let price_list_date: Date | undefined;

        if (dateMoment) {
            price_list_date = dateMoment.toDate();
        }

        this.setState({
            price_list_date,
        });
    };

    handleDeliveryEta = (deliveryEta: Moment) => {
        this.setState({
            delivery_eta: deliveryEta,
        });
    };

    handlePricingDescriptionChange = (pricingDescriptions: { [key: string]: string }) => {
        const stateUpdate: any = {
            catalog_item: {
                ...this.state.catalog_item,
            },
        };

        stateUpdate.pricing_descriptions = pricingDescriptions;
        stateUpdate.catalog_item.pricing_descriptions = pricingDescriptions;

        this.setState(stateUpdate);
    };

    handlePriceBandChange = (band: IPrice_Band_Compiled[], priceGroup?: IPrice_Group, vendorSource?: IVendor_Source) => {
        // console.log("handlePriceBandChange", band, priceGroup, vendorSource);

        const stateUpdate: any = {
            catalog_item: {
                ...this.state.catalog_item,
            },
            priceBands: {
                ...this.state.priceBands,
            },
        };

        if (priceGroup) {
            stateUpdate.priceBands[priceGroup.value] = band;
            // stateUpdate.catalog_item.Price_Bands[priceGroup.value] = band;
        } else if (vendorSource) {
            stateUpdate.priceBands[`${vendorSource.name}_cost`] = band;
            // stateUpdate.catalog_item.Price_Bands[`${vendorSource.name}_cost`] = band;
        } else {
            stateUpdate.priceBands[`cost`] = band;
        }

        // console.log("handlePriceBandChange", stateUpdate, band);

        this.setState(stateUpdate);
    };

    setUomSet = (set: IUnit_Of_Measurement_Set | null) => {
        this.setState({
            base_unit_id: set ? set.id : null,
        });
    };

    setPurchasingUomId = (id: number | null) => {
        this.setState({
            purchasing_base_unit_id: id,
        });
    };

    handleUpdatePricing = (pricing: { [key: string]: number | "N/A" }) => {
        const stateUpdate: any = {
            catalog_item: {
                ...this.state.catalog_item,
            },
        };

        stateUpdate.pricing = pricing;
        stateUpdate.pricing_dirty = true;
        stateUpdate.catalog_item.pricing = pricing;

        this.setState(stateUpdate);
    };

    handleChange = (e: any) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        // Check if toggling is_kit_builder ON with existing kit items
        if (name === "is_kit_builder" && value === true && this.state.updated_kit_items.length > 0) {
            this.setState({ showKitBuilderConversionModal: true });
            return;
        }

        const stateUpdate: any = {
            catalog_item: {
                ...this.state.catalog_item,
            },
        };

        stateUpdate[name] = value;
        stateUpdate.catalog_item[name] = value;

        let skuTitle: string | undefined;

        if (name === "is_product_group") {
            skuTitle = this.getSkuTitle(value);
            stateUpdate.skuTitle = skuTitle;
            if (value) {
                stateUpdate.create_in_qbo = false;
                stateUpdate.create_in_qbd = false;
            }
        }

        // Bypass-production only applies to serialized items, and its toggle is
        // hidden once has_serials is off — clear it so a stale value can't persist.
        if (name === "has_serials" && !value) {
            stateUpdate.bypass_production_workflow = false;
            stateUpdate.catalog_item.bypass_production_workflow = false;
        }

        // When the SKU itself changes, re-check the catalog for duplicates.
        // The duplicate check only runs when auto_gen_sku is enabled.
        if (name === "sku" && this.props.supplierModel.auto_gen_sku) {
            stateUpdate.skuLookupStatus = value && value.length ? "checking" : undefined;
            stateUpdate.skuLookupMatches = undefined;
        }

        // Compute formValid inline to avoid a second setState/render cycle
        const newName = name === "name" ? value : this.state.name;
        const newSku = name === "sku" ? value : this.state.sku;
        const newStatus = name === "sku" ? stateUpdate.skuLookupStatus : this.state.skuLookupStatus;
        stateUpdate.formValid = this.isFormValid(newName, newSku, newStatus);

        this.setState(stateUpdate, () => {
            if (name === "sku" && this.props.supplierModel.auto_gen_sku) {
                this.runSkuDuplicateCheck();
            } else if (name === "name") {
                // In the create flow there's no load event, so auto-generate the
                // SKU from the name as the user types (when enabled and SKU blank).
                this.runAutoGenerateSku();
            }
        });
    };

    /**
     * Whether the form can be saved. Requires a name and SKU, and — when the
     * supplier has auto_gen_sku enabled — that the SKU isn't already in use by
     * another catalog item.
     */
    isFormValid = (name?: string, sku?: string, skuLookupStatus?: State["skuLookupStatus"]): boolean => {
        if (!(name && name.length && sku && sku.length)) {
            return false;
        }

        if (this.props.supplierModel.auto_gen_sku && skuLookupStatus === "duplicate") {
            return false;
        }

        return true;
    };

    /**
     * Debounced wrapper around the SKU duplicate check so we don't fire a
     * request on every keystroke.
     */
    runSkuDuplicateCheck = _.debounce(() => {
        this.checkSkuForDuplicates();
    }, 400);

    /**
     * Debounced wrapper around the SKU auto-generation so typing a name doesn't
     * regenerate on every keystroke.
     */
    runAutoGenerateSku = _.debounce(() => {
        this.maybeAutoGenerateSku();
    }, 500);

    /**
     * Query the catalog for items already using the current SKU and update the
     * inline availability feedback. The catalog item currently being edited is
     * excluded from the matches so it never flags itself as a duplicate.
     */
    checkSkuForDuplicates = async () => {
        const sku = (this.state.sku || "").trim();

        if (!sku.length) {
            this.setState({ skuLookupStatus: undefined, skuLookupMatches: undefined });
            return;
        }

        try {
            const result = await CatalogItemService.lookupCatalogItemBySku(
                this.props.catalogGuid,
                sku,
                this.props.userModel,
                this.props.supplierModel
            );

            // Guard against a stale response if the user kept typing.
            if ((this.state.sku || "").trim() !== sku) {
                return;
            }

            const currentItemId = this.state.catalog_item?.id;
            const matches = (result.catalog_items || []).filter((item) => item.id !== currentItemId);
            const status = matches.length ? "duplicate" : "available";

            this.setState((prev) => ({
                skuLookupStatus: status,
                skuLookupMatches: matches,
                formValid: this.isFormValid(prev.name, prev.sku, status),
            }));
        } catch (e) {
            // On failure, simply clear the indicator rather than blocking the user.
            this.setState((prev) => ({
                skuLookupStatus: undefined,
                skuLookupMatches: undefined,
                formValid: this.isFormValid(prev.name, prev.sku, undefined),
            }));
        }
    };

    /**
     * After a catalog item loads, auto-generate a SKU from the name when the
     * supplier has auto_gen_sku enabled, the SKU is blank, and a name exists.
     * Honors the 31 character QuickBooks Desktop limit when applicable.
     */
    maybeAutoGenerateSku = () => {
        if (!this.props.supplierModel.auto_gen_sku) {
            return;
        }

        const hasSku = !!(this.state.sku && this.state.sku.trim().length);
        const hasName = !!(this.state.name && this.state.name.trim().length);

        if (hasSku || !hasName) {
            return;
        }

        const maxLength = this.props.supplierModel.Supplier_Integration.has_qbd ? 31 : undefined;
        const sku = CatalogItemService.generateSkuFromName(this.state.name!, maxLength);

        if (!sku.length) {
            return;
        }

        this.setState(
            (prev) => ({
                sku,
                skuLookupStatus: "checking",
                skuLookupMatches: undefined,
                formValid: this.isFormValid(prev.name, sku, "checking"),
            }),
            () => {
                this.runSkuDuplicateCheck();
            }
        );
    };

    /**
     * Inline feedback under the SKU input indicating whether the current SKU is
     * already used by another catalog item. Shows a checkmark when available and
     * an X when a duplicate exists, with translated supporting text.
     */
    renderSkuLookupFeedback = () => {
        const status = this.state.skuLookupStatus;

        if (!status) {
            return null;
        }

        if (status === "checking") {
            return (
                <div className={"mt-1 d-flex align-items-center text-muted"}>
                    <i className={"fad fa-spinner-third fa-spin me-1"} />
                    <OwLabel title={"checking_sku_availability"} noBottomMargin={true} className={"text-muted"} />
                </div>
            );
        }

        if (status === "duplicate") {
            return (
                <div className={"mt-1 d-flex align-items-center text-danger"}>
                    <i className={"fas fa-times-circle me-1"} />
                    <OwLabel title={"sku_already_in_use"} noBottomMargin={true} className={"text-danger"} />
                </div>
            );
        }

        return (
            <div className={"mt-1 d-flex align-items-center text-success"}>
                <i className={"fas fa-check-circle me-1"} />
                <OwLabel title={"sku_available"} noBottomMargin={true} className={"text-success"} />
            </div>
        );
    };

    /**
     * Determine the SKU Label Title based on if the catalog item
     * is a product group.
     */
    getSkuTitle = (isProductGroup: boolean): string => {
        if (isProductGroup) {
            return "base_sku";
        } else {
            return "sku";
        }
    };

    getUnitMeasurementSelectOption = (selectedOption: any) => {
        const options = SystemConst.UnitOfMeasurementOptions;

        return (
            <OwSelectOption
                options={options}
                titleProp={"title"}
                valueProp={"id"}
                selectedOption={this.state}
                selectedOptionProp={"unit_of_measurement_id"}
                fn={this.handleChange}
                name={"unit_of_measurement_id"}
                showBlankFirst={true}
            />
        );
    };

    getPriceGroupInputs = () => {
        if (this.props.priceGroups) {
            const priceGroups = this.state.priceGroups; // Object.keys(this.state.pricing);

            return priceGroups.map((priceGroup, index) => {
                const name = `pricing['${priceGroup.value}']`;
                const pricingDescription = `pricing_descriptions['${priceGroup.value}']`;

                const value = _.get(this.state, `${name}`, 0);
                const descriptionValue = _.get(this.state, `${pricingDescription}`, "");

                let profitPer = 0;
                let profitMargin = 0;
                let profitClassName = "text-success";

                if (!_.isNil(this.state.cost_per_uom) && this.props.supplierModel.has_cost_pricing) {
                    if (_.isNumber(Number(value)) && value.toString() !== "N/A") {
                        const cost = Number(this.state.cost_per_uom);

                        profitPer = value - cost;
                        const grossProfit = value - cost;
                        profitMargin = (grossProfit / value) * 100;

                        if (profitMargin < 0) {
                            profitClassName = "text-danger";
                        } else if (profitMargin > 0) {
                            profitClassName = "text-success";
                        } else {
                            profitClassName = "text-warning";
                        }
                    }
                }

                return (
                    <div key={index}>
                        <OwLabel title={priceGroup.value} noBottomMargin={true} skipTranslate={true} />
                        {_.isNumber(Number(value)) && value.toString() !== "N/A" ? (
                            <div>
                                <NumericFormat
                                    value={value}
                                    onChange={this.handleChange}
                                    name={name}
                                    className="form-control form-control-sm"
                                />
                                {this.state.cost_per_uom ? (
                                    <div>
                                        <OwLabel title={"profit"} noBottomMargin={true} className={"me-1"} />
                                        <span className={profitClassName}>
                                            <FormattedNumber value={profitPer} maximumFractionDigits={2} />
                                        </span>

                                        <OwLabel title={"margin"} noBottomMargin={true} className={"me-1 ms-5"} />
                                        <span className={profitClassName}>
                                            <FormattedNumber value={profitMargin} maximumFractionDigits={2} />%
                                        </span>
                                    </div>
                                ) : null}
                                {this.props.supplierModel.has_pricing_descriptions ? (
                                    <div>
                                        <div>
                                            <OwLabel title={"description"} />
                                        </div>
                                        <div>
                                            <OwFnInput
                                                fn={this.handlePricingDescriptionChange}
                                                name={pricingDescription}
                                                value={descriptionValue}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div>N/A</div>
                        )}
                        <OwCheckbox
                            truthyVal={"N/A"}
                            falsyVal={0}
                            checked={value.toString() === "N/A"}
                            fn={this.handleChange}
                            name={name}
                            label={"not_available"}
                        />
                    </div>
                );
            });
        }
    };

    isImageProcessed = (isProcessed: boolean) => {
        if (isProcessed) {
            this.getCatalogItem();
        }
    };

    setCategoryId = (id: number | null) => {
        this.setState({
            category_id: id,
        });
    };

    handleAttributesChange = (attributes: ICatalog_Item_Attribute[]) => {
        this.setState({
            catalogItemAttributes: attributes,
        });
    };

    setDiscounts = (discounts: IDiscount[]) => {
        this.setState({
            discounts: discounts.map((discount) => discount.id),
        });
    };

    updateGroupItems = (groupItems: IGroupItem[]) => {
        this.setState({
            group_items: groupItems,
        });
    };

    updateMultiGroupSections = (sections: IGroupSubsectionUI[]) => {
        this.setState({ multi_group_items: sections });
    };

    updateAutomations = (automation: IAutomation) => {
        const automations = this.state.automations;

        automations.push(automation);

        this.setState({
            automations,
        });
    };

    deleteAutomations = (automation: IAutomation, index: number) => {};

    updateMaterials = (qtySet: { material: IMaterial; qty: number }[]) => {
        this.setState({
            materialsQtySet: qtySet,
        });
    };

    deleteMaterial = (material: IMaterial, index: number) => {
        const materials = this.state.materials;

        materials.splice(index, 1);

        const materialsQtySet = this.state.materialsQtySet;

        materialsQtySet.splice(index, 1);

        this.setState({
            materials,
            materialsQtySet,
        });
    };

    updateProductSources = (sources: ICatalog_Item[]) => {
        this.setState(
            {
                productSources: sources,
            },
            () => {
                // console.log("updateProductSources", this.state.productSources);
            }
        );
    };

    updateVendorSources = (sources: IVendorSourceItem[], defaultVendorSourceId?: number | null) => {
        const currentDefaultVendorSourceId = this.state.defaultVendorSourceId;

        if (currentDefaultVendorSourceId === defaultVendorSourceId) {
            defaultVendorSourceId = null;
        }

        this.setState({
            vendorSources: sources,
            defaultVendorSourceId,
        });
    };

    getAttachmentDownloadLink = (catalogItem: ICatalog_ItemUI) => {
        if (catalogItem && catalogItem.Attachments && catalogItem.file_attachment_one_id) {
            let attachmentItem: IAttachment | null = null;

            for (const attachment of catalogItem.Attachments) {
                if (attachment.id === catalogItem.file_attachment_one_id) {
                    attachmentItem = attachment;
                }
            }

            if (attachmentItem) {
                return <OwS3DownloadLink attachment={attachmentItem} leftIconName={"fad fa-download"} title={"download"} />;
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    updateWarehouseMap = (warehouseMap: IWarehouseItem[]) => {
        this.setState({
            warehouseMap,
        });
    };

    updateKitBuilderOptions = (options: (IKit_Builder_OptionUI | Partial<IKit_Builder_OptionUI>)[]) => {
        this.setState({
            updated_kit_builder_options: options,
        });
    };

    updateKitItemsFn = (kitItems: (IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[]) => {
        this.setState({
            updated_kit_items: kitItems,
        });
    };

    /** The detail's Bom_Lines as editable rows (OR-1457). */
    static bomLinesFromItem = (catalogItem?: ICatalog_Item | null): IBomLineUI[] => {
        const bomLines = _.get(catalogItem, "Bom_Lines", []) || [];

        return bomLines.map((line) => ({
            id: line.id,
            component_catalog_item_id: line.component_catalog_item_id,
            qty_per_unit: line.qty_per_unit,
            Component: line.Component,
        }));
    };

    /** Component status by component id from the latest detail's Bom_Lines (OR-1460); empty when not sent. */
    static bomShortagesFromItem = (catalogItem?: ICatalog_Item | null): Record<number, IComponentShortage> => {
        const shortages: Record<number, IComponentShortage> = {};

        for (const line of _.get(catalogItem, "Bom_Lines", []) || []) {
            if (line.shortage) {
                shortages[line.component_catalog_item_id] = line.shortage;
            }
        }

        return shortages;
    };

    updateBomLines = (bomLines: IBomLineUI[]) => {
        this.setState({
            bom_lines: bomLines,
            bom_lines_dirty: true,
        });
    };

    updateKitBuilderBaseItemsFn = (baseItems: (IKit_Catalog_Items_MapUI | INewKit_Catalog_Items_MapUI)[]) => {
        this.setState({
            updated_kit_builder_base_items: baseItems,
        });
    };

    handleKitBuilderConversionConvert = () => {
        // Convert existing kit items to base items
        const baseItems = this.state.updated_kit_items.map((item) => ({
            ...item,
            is_kit_base_option: true,
        }));

        const updatedCatalogItem = this.state.catalog_item ? { ...this.state.catalog_item, is_kit_builder: true } : this.state.catalog_item;

        this.setState({
            is_kit_builder: true,
            showKitBuilderConversionModal: false,
            updated_kit_builder_base_items: baseItems,
            kit_builder_base_items: baseItems,
            catalog_item: updatedCatalogItem,
        });
    };

    handleKitBuilderConversionStartFresh = () => {
        // Start fresh - don't carry over existing items
        const updatedCatalogItem = this.state.catalog_item ? { ...this.state.catalog_item, is_kit_builder: true } : this.state.catalog_item;

        this.setState({
            is_kit_builder: true,
            showKitBuilderConversionModal: false,
            updated_kit_builder_base_items: [],
            kit_builder_base_items: [],
            catalog_item: updatedCatalogItem,
        });
    };

    handleKitBuilderConversionCancel = () => {
        this.setState({
            showKitBuilderConversionModal: false,
        });
    };

    calculateCubes = () => {
        if (this.state.height && this.state.width && this.state.depth) {
            return Number(this.state.height) * Number(this.state.width) * Number(this.state.depth);
        } else {
            return 0;
        }
    };

    selectVendorSource = (e: ChangeEvent<any>) => {
        if (this.props.vendorSources) {
            const value = e.target.value;

            const vendorSource = this.props.vendorSources.find((source) => {
                return Number(source.id) === Number(value);
            });

            this.setState({
                selectedVendorSource: vendorSource,
            });
        }
    };

    selectVendorSourceLocation = (e: ChangeEvent<any>) => {
        if (this.props.vendorSources && this.state.selectedVendorSource?.Vendor_Source_Locations) {
            const value = e.target.value;

            const vendorSourceLocation = this.state.selectedVendorSource.Vendor_Source_Locations.find((location) => {
                return Number(location.id) === Number(value);
            });

            this.setState({
                selectedVendorSourceLocation: vendorSourceLocation,
            });
        }
    };

    addLocation = () => {
        if (this.state.selectedVendorSourceLocation && this.state.selectedVendorSource) {
            const vendorLocation = this.state.selectedVendorSourceLocation;
            const vendorLocations = this.state.selectedVendorSourceLocations;

            if (!vendorLocation.Vendor_Source) {
                vendorLocation.Vendor_Source = this.state.selectedVendorSource;
            }

            vendorLocations.push(vendorLocation);

            this.setState({
                selectedVendorSourceLocations: vendorLocations,
                hasPendingLocationChanges: true,
            });
        }
    };

    removeLocation = (location: IVendor_Source_Location, index: number) => {
        if (this.state.selectedVendorSourceLocations) {
            const locations = this.state.selectedVendorSourceLocations;

            if (location.id) {
                locations[index].deleteFlag = true;
            } else {
                locations.splice(index, 1);
            }

            this.setState({
                selectedVendorSourceLocations: locations,
                hasPendingLocationChanges: true,
            });
        }
    };

    getTaxJarCategories = (name: string) => {
        const payload: ITaxJarGetTaxCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `name=${name}`,
            limit: 20,
        };

        this.props.socket.emit(EndpointsEnum.TaxJarGetTaxCategories, payload);
    };

    onGetTaxJarCategories = (data: ITaxJarOnGetTaxCategoriesDTO) => {
        this.setState({
            taxJarCategories: data.categories,
        });
    };

    selectTaxJarCategory = (category: ITaxJar_Category) => {
        this.setState({
            taxjar_category_id: category.id,
            selectedTaxJarCategory: category,
        });
    };

    getPricingFormulas = (name: string) => {
        const payload: IGetPricingFormulasDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };
        this.props.socket.emit(EndpointsEnum.CatalogsGetPricingFormulas, payload);
    };

    onGetPricingFormulas = (data: IOnGetPricingFormulasDTO) => {
        this.setState({
            pricingFormulas: data.pricingFormulas,
        });
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        // Keep whatever pricing is already in state (detail response or local edits) and only make sure
        // every price group has an entry; rebuilding from props would drop both.
        const pricing = CatalogItemService.hydratePricing(this.state.pricing, undefined, data.priceGroups, true);

        this.setState({
            priceGroups: data.priceGroups,
            pricing,
        });
    };

    selectPricingFormula = (formula: IPricing_Formula) => {
        this.setState({
            pricing_formula_id: formula.id,
            selectedPricingFormula: formula,
        });
    };

    updateChildItems = (mapItems: ICatalog_Item_Child_Item_MapUI[]) => {
        this.setState({
            child_items: mapItems,
        });
    };

    updateItemOptions = (itemOptions: (ICatalog_Item_Option | INewCatalog_Item_Option)[]) => {
        // console.log("updateItemOptions", itemOptions);

        this.setState({
            itemOptionValues: itemOptions,
        });
    };

    render() {
        let header_title = "create_catalog_item";

        if (this.state.existingCatalogItem) {
            header_title = "update_catalog_item";
        }

        const unitMeasurementSelectOption = this.getUnitMeasurementSelectOption(this.state.catalog_item);

        const priceGroupInputs = this.getPriceGroupInputs();

        let has_qbo = _.get(this.props.supplierModel, "Supplier_Integration.has_qbo", false);
        let has_qbd = _.get(this.props.supplierModel, "Supplier_Integration.has_qbd", false);
        const show_common_items_modal = _.get(this.props.supplierModel, "show_common_items_modal", false);

        has_qbo = _.isNil(has_qbo) ? false : has_qbo;
        has_qbd = _.isNil(has_qbd) ? false : has_qbd;

        const catalogItem: ICatalog_ItemUI | undefined = this.state.catalog_item;

        const groupCatalogItems: any[] = this.state.group_items || [];

        const dimensionUnitOptions = SystemConst.DimensionUnitOptions;

        let taxJarLogoSrc = taxJarLogo;

        if (UIService.isMainViewLight()) {
            taxJarLogoSrc = taxJarLightLogo;
        }

        return (
            <div className="CreateCatalogItemSidebar d-flex">
                <div className={"sidebar-container d-flex flex-column"}>
                    <div className={"p-2 "}>
                        <div className="text-end">
                            <button className="btn btn-danger btn-sm" onClick={this.cancel}>
                                <i className="far fa-times" />
                            </button>
                        </div>
                        <OwTitle leftIconName={"far fa-book"} title={header_title} />
                        <OwTitle title={this.state.name || ""} tag={"h5"} disableTranslation={true} />
                        {this.props.showHiddenFeatures && this.state.catalog_item?.id ? (
                            <div className={"mt-3"}>
                                <div className="d-flex align-items-center">
                                    <div className="me-2">GUID:</div>
                                    <ClickToCopy text={this.state.catalog_item?.guid || ""} noFlexGrow={true} />
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="me-2">ID:</div>
                                    <ClickToCopy text={this.state.catalog_item?.id.toString() || ""} noFlexGrow={true} />
                                </div>
                                <div>
                                    <OwButton title="console.log" fn={() => console.log(this.state.catalog_item)} />
                                </div>
                            </div>
                        ) : null}
                        <hr />
                    </div>
                    {this.state.group_parent_catalog_item_id ? (
                        <div className="ps-2 pe-2 d-flex flex-column">
                            <div>
                                <i className="fad fa-info-circle me-1" />
                                <FormattedMessage
                                    id="item_is_product_group_item"
                                    values={{ name: this.state.catalog_item?.Group_Catalog_Item?.name }}
                                />
                            </div>
                            <div>
                                <OwButton
                                    title="remove_from_group"
                                    fn={() => this.setState({ group_parent_catalog_item_id: null })}
                                    className="btn-sm btn-outline-danger"
                                />
                            </div>
                        </div>
                    ) : this.state.original_group_parent_catalog_item_id ? (
                        <div className="ps-2 pe-2 d-flex flex-column">
                            <div>
                                <i className="fad fa-info-circle me-1" />
                                <FormattedMessage
                                    id="item_is_product_group_item"
                                    values={{ name: this.state.catalog_item?.Group_Catalog_Item?.name }}
                                />
                                <span className="ms-1 text-danger">
                                    (<FormattedMessage id="removed" />)
                                </span>
                            </div>
                            <div className="mt-2">
                                <OwButton
                                    title="undo"
                                    fn={() =>
                                        this.setState({ group_parent_catalog_item_id: this.state.original_group_parent_catalog_item_id })
                                    }
                                    className="btn-sm btn-outline-secondary"
                                />
                            </div>
                        </div>
                    ) : null}
                    <div className="CatalogItemForm flex-item ps-2 pe-2">
                        <div className={"mb-2"}>
                            <div className={"bd-callout"}>
                                <OwLabel title={"details"} description={"Details Title"} leftIconClass={"fad fa-square-info"} />
                            </div>

                            <hr />

                            {this.props.supplierModel.Supplier_Integration.has_wayfair ? (
                                <div className={"mt-5"}>
                                    <OwToggle
                                        label={"wayfair_item"}
                                        name={"wayfair_item"}
                                        active={!!this.state.wayfair_item}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            <div>
                                <OwToggle
                                    label={"is_common_item"}
                                    name={"is_common_item"}
                                    active={this.state.is_common_item || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                />
                            </div>

                            <div>
                                <OwToggle
                                    label={"is_product_group"}
                                    name={"is_product_group"}
                                    active={this.state.is_product_group || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                    disabled={this.state.is_alternate_source || this.state.has_alternate_sourcing || this.state.is_kit}
                                />
                            </div>

                            <div>
                                <OwToggle
                                    label={"is_kit"}
                                    name={"is_kit"}
                                    active={this.state.is_kit || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                    disabled={this.state.is_product_group}
                                />
                            </div>

                            {this.props.supplierModel.has_sum_to_single_invoice_item ? (
                                <div>
                                    <OwToggle
                                        label={"sum_to_single_invoice_item"}
                                        name={"sum_to_single_invoice_item"}
                                        active={this.state.sum_to_single_invoice_item || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_new_releases_category ? (
                                <div>
                                    <OwToggle
                                        label={"is_new_release"}
                                        name={"is_new_release"}
                                        active={this.state.is_new_release || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_ready_to_ship_category ? (
                                <div>
                                    <OwToggle
                                        label={"is_ready_to_ship"}
                                        name={"is_ready_to_ship"}
                                        active={this.state.is_ready_to_ship || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_product_sources ? (
                                <div>
                                    <OwToggle
                                        label={"has_alternate_sourcing"}
                                        name={"has_alternate_sourcing"}
                                        active={this.state.has_alternate_sourcing || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_product_sources ? (
                                <div>
                                    <OwToggle
                                        label={"is_alternate_source"}
                                        name={"is_alternate_source"}
                                        active={this.state.is_alternate_source || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            {this.state.is_alternate_source ? (
                                <div>
                                    <OwToggle
                                        label={"is_customer_orderable"}
                                        name={"is_customer_orderable"}
                                        active={this.state.is_customer_orderable || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                            ) : null}

                            <hr />

                            <div className={"d-flex justify-content-between mt-3"}>
                                <OwLabel title={"name"} description={"Name Title"} showIsReqAsterik={true} />
                                {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                                    <OwCharCount inputString={this.state.name} maxLength={31} />
                                ) : null}
                            </div>
                            <OwInputWrapper
                                value={this.state.name}
                                name={"name"}
                                fn={this.handleChange}
                                isRequired={true}
                                maxLength={this.props.supplierModel.Supplier_Integration.has_qbd ? 31 : undefined}
                                autoFocus={true}
                                disableKeyUp={true}
                            />
                            {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                                <div>
                                    <OwLabel title={"qbd_max_31_characters"} noBottomMargin={true} className={"text-warning"} />
                                </div>
                            ) : null}
                        </div>

                        <div className={"mt-2"}>
                            <div className={"d-flex justify-content-between"}>
                                <OwLabel
                                    title={this.state.skuTitle ? this.state.skuTitle : "sku"}
                                    description={"SKU Title"}
                                    showIsReqAsterik={true}
                                />
                                {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                                    <OwCharCount inputString={this.state.sku} maxLength={31} />
                                ) : null}
                            </div>
                            <OwInputWrapper
                                value={this.state.sku}
                                name={"sku"}
                                fn={this.handleChange}
                                isRequired={true}
                                maxLength={this.props.supplierModel.Supplier_Integration.has_qbd ? 31 : undefined}
                                disableKeyUp={true}
                            />
                            {this.props.supplierModel.Supplier_Integration.has_qbd ? (
                                <div>
                                    <OwLabel title={"qbd_max_31_characters"} noBottomMargin={true} className={"text-warning"} />
                                </div>
                            ) : null}
                            {this.renderSkuLookupFeedback()}
                        </div>

                        {!this.state.is_product_group ? (
                            <>
                                <div className={"mt-2"}>
                                    <OwLabel title={"upc"} description={"UPC Title"} />
                                    <OwFnInput
                                        type={"number"}
                                        maxLength={12}
                                        max={12}
                                        min={12}
                                        value={this.state.upc}
                                        name={"upc"}
                                        fn={this.handleChange}
                                    />
                                </div>
                                <div className={"mt-2"}>
                                    <OwLabel title={"ean"} description={"EAN Title"} />
                                    <OwInputWrapper
                                        type={"text"}
                                        maxLength={13}
                                        max={13}
                                        min={13}
                                        value={this.state.ean}
                                        name={"ean"}
                                        fn={this.handleChange}
                                    />
                                </div>
                            </>
                        ) : null}

                        <div className={"mt-2"}>
                            <OwLabel title={"manufacturer"} />
                            <OwInputWrapper value={this.state.manufacturer} name={"manufacturer"} fn={this.handleChange} />
                        </div>

                        <div className={"mt-2"}>
                            <OwLabel title={"price_list_date"} />
                            <OwDateInput selectedDate={this.state.price_list_date} fn={this.handlePriceListDate} noZIndex={true} />
                        </div>

                        <div className={"mt-2"}>
                            <OwLabel title={"short_description"} description={"Short Description Title"} />
                            <OwTextArea fn={this.handleChange} name={"short_description"} value={this.state.short_description} />
                        </div>

                        <div className={"mt-2"}>
                            <div className={"d-flex justify-content-between"}>
                                <OwLabel title={"description"} description={"Description Title"} />
                                {this.state.description?.length ? (
                                    <div>
                                        {this.state.description?.length}
                                        <OwLabel title={"chars"} className={"ms-1"} />
                                    </div>
                                ) : null}
                            </div>
                            <OwTextArea fn={this.handleChange} name={"description"} value={this.state.description} rows={5} />
                        </div>

                        <div className={"mt-2"}>
                            <OwLabel title={"purchase_link"} description={"Purchase Link Title"} />
                            <OwInputWrapper fn={this.handleChange} name={"purchase_link"} value={this.state.purchase_link} />
                        </div>

                        {this.props.supplierModel.has_automation ? (
                            <div className={"mt-2"}>
                                <div>
                                    <OwLabel title={"third_party_sku"} description={"Third Party Sku Title"} />
                                    <OwInputWrapper value={this.state.third_party_sku} name={"third_party_sku"} fn={this.handleChange} />
                                </div>
                                <div>
                                    <OwLabel title={"third_party_pricing"} description={"Third Party Pricing Title"} />
                                    <OwInputWrapper
                                        value={this.state.third_party_pricing}
                                        name={"third_party_pricing"}
                                        fn={this.handleChange}
                                    />
                                </div>
                                <div>
                                    <OwLabel title={"third_party_size"} description={"Third Party Size Title"} />
                                    <OwInputWrapper value={this.state.third_party_size} name={"third_party_size"} fn={this.handleChange} />
                                </div>
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_catalog_item_delivery_eta ? (
                            <div className={"mt-2"}>
                                <OwLabel title={"delivery_eta"} />
                                <OwDateInput
                                    fn={this.handleDeliveryEta}
                                    dateFormat={"MM/dd/yyyy"}
                                    selectedDate={this.state.delivery_eta}
                                    noZIndex={true}
                                />
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_dimensions ? (
                            <div className="mt-4 mb-4">
                                <div>
                                    <OwLabel title={"width"} />
                                    <OwInputWrapper value={this.state.width} name={"width"} fn={this.handleChange} />
                                    <OwToggle
                                        wrapperClassName="mt-2"
                                        labelOnRight={true}
                                        fn={this.handleChange}
                                        name="user_entered_width"
                                        label="user_entered_width"
                                        active={this.state.user_entered_width || false}
                                    />
                                </div>
                                <div>
                                    <OwLabel title={"height"} />
                                    <OwInputWrapper value={this.state.height} name={"height"} fn={this.handleChange} />
                                    <OwToggle
                                        wrapperClassName="mt-2"
                                        labelOnRight={true}
                                        fn={this.handleChange}
                                        name="user_entered_height"
                                        label="user_entered_height"
                                        active={this.state.user_entered_height || false}
                                    />
                                </div>
                                <div>
                                    <OwLabel title={this.props.supplierModel.length_for_depth ? "length" : "depth"} />
                                    <OwInputWrapper value={this.state.depth} name={"depth"} fn={this.handleChange} />
                                    <OwToggle
                                        wrapperClassName="mt-2"
                                        labelOnRight={true}
                                        fn={this.handleChange}
                                        name="user_entered_depth"
                                        label={this.props.supplierModel.length_for_depth ? "user_entered_length" : "user_entered_depth"}
                                        active={this.state.user_entered_depth || false}
                                    />
                                </div>
                                <div>
                                    <OwLabel title={"dimension_unit"} showIsReqAsterik={true} />
                                    <OwSelectOption
                                        titleProp={"abbreviation"}
                                        valueProp={"id"}
                                        fn={this.handleChange}
                                        name={"dimension_unit_id"}
                                        options={dimensionUnitOptions}
                                        selectedOption={this.state}
                                        selectedOptionProp={"dimension_unit_id"}
                                        isRequired={true}
                                        showBlankFirst={true}
                                    />
                                </div>

                                <div className="mt-4">
                                    <OwLabel title={"case_width"} />
                                    <OwInputWrapper value={this.state.case_width} name={"case_width"} fn={this.handleChange} />
                                </div>
                                <div>
                                    <OwLabel title={"case_height"} />
                                    <OwInputWrapper value={this.state.case_height} name={"case_height"} fn={this.handleChange} />
                                </div>
                                <div>
                                    <OwLabel title={this.props.supplierModel.length_for_depth ? "case_length" : "case_depth"} />
                                    <OwInputWrapper value={this.state.case_depth} name={"case_depth"} fn={this.handleChange} />
                                </div>
                                <div>
                                    <OwLabel title={"case_dimension_unit"} showIsReqAsterik={true} />
                                    <OwSelectOption
                                        titleProp={"abbreviation"}
                                        valueProp={"id"}
                                        fn={this.handleChange}
                                        name={"case_dimension_unit_id"}
                                        options={dimensionUnitOptions}
                                        selectedOption={this.state}
                                        selectedOptionProp={"case_dimension_unit_id"}
                                        isRequired={true}
                                        showBlankFirst={true}
                                    />
                                </div>
                            </div>
                        ) : null}

                        <div className={"mt-2 mb-4"}>
                            <div>
                                <OwLabel title={"case_weight"} />
                            </div>
                            <OwInputWrapper name={"case_weight"} fn={this.handleChange} value={this.state.case_weight} />
                            <div>
                                <OwLabel title={"case_weight_unit"} />
                            </div>
                            <OwSelectOption
                                titleProp={"title"}
                                valueProp={"id"}
                                fn={this.handleChange}
                                name={"case_weight_unit_id"}
                                options={SystemConst.WeightUnitOptions}
                                selectedOption={this.state}
                                selectedOptionProp={"case_weight_unit_id"}
                            />
                        </div>

                        <div className={"mt-4"}>
                            <div>
                                <OwLabel title={"item_weight"} />
                            </div>
                            <OwInputWrapper name={"item_weight"} fn={this.handleChange} value={this.state.item_weight} />
                            <div>
                                <OwLabel title={"item_weight_unit"} />
                            </div>
                            <OwSelectOption
                                titleProp={"title"}
                                valueProp={"id"}
                                fn={this.handleChange}
                                name={"item_weight_unit_id"}
                                options={SystemConst.WeightUnitOptions}
                                selectedOption={this.state}
                                selectedOptionProp={"item_weight_unit_id"}
                            />
                        </div>

                        <div className={"mt-2 mb-4"}>
                            <div>
                                <OwLabel title={"shipping_weight"} />
                            </div>
                            <OwInputWrapper name={"shipping_weight"} fn={this.handleChange} value={this.state.shipping_weight} />
                            <div>
                                <OwLabel title={"shipping_weight_unit"} />
                            </div>
                            <OwSelectOption
                                titleProp={"title"}
                                valueProp={"id"}
                                fn={this.handleChange}
                                name={"shipping_weight_unit_id"}
                                options={SystemConst.WeightUnitOptions}
                                selectedOption={this.state}
                                selectedOptionProp={"shipping_weight_unit_id"}
                            />
                        </div>

                        <div className={this.state.showColorStyleInput ? "" : "d-none"}>
                            <div className={"mt-2"}>
                                <OwLabel title={"color"} description={"Color"} />
                                <OwInputWrapper fn={this.handleChange} name={"color"} value={this.state.color} />
                            </div>

                            <div className={"mt-2"}>
                                <OwLabel title={"style"} description={"Style"} />
                                <OwInputWrapper fn={this.handleChange} name={"style"} value={this.state.style} />
                            </div>
                        </div>

                        <div className={"mt-2"}>
                            <div>
                                <OwLabel title={"item_order"} />
                            </div>
                            <div>
                                <OwInputWrapper name={"item_order"} fn={this.handleChange} value={this.state.item_order} />
                            </div>
                        </div>

                        {this.state.is_product_group ? (
                            <div className={"productGroup mt-5"}>
                                {/* Mode selector — only for new (unsaved) items */}
                                {!this.state.catalog_item?.guid &&
                                    (() => {
                                        const hasItems =
                                            this.state.multi_group_items.filter((s) => !s.deleteFlag).length > 0 ||
                                            (this.state.group_items?.length ?? 0) > 0;
                                        return (
                                            <div className={"mb-3 d-flex align-items-center gap-3"}>
                                                <OwLabel title={"product_group_type"} isBold={true} noBottomMargin />
                                                <div className={"d-flex align-items-center gap-3"}>
                                                    <label className={"d-flex align-items-center gap-1 mb-0 pointer"}>
                                                        <input
                                                            type="radio"
                                                            name="product_group_type"
                                                            value="flat"
                                                            disabled={hasItems}
                                                            checked={
                                                                !this.state.product_group_type || this.state.product_group_type === "flat"
                                                            }
                                                            onChange={() => this.setState({ product_group_type: "flat" })}
                                                        />
                                                        <span className={"OwLabel mb-0"}>
                                                            <FormattedMessage id={"flat"} defaultMessage={"_flat_"} />
                                                        </span>
                                                    </label>
                                                    <label className={"d-flex align-items-center gap-1 mb-0 pointer"}>
                                                        <input
                                                            type="radio"
                                                            name="product_group_type"
                                                            value="multi"
                                                            disabled={hasItems}
                                                            checked={this.state.product_group_type === "multi"}
                                                            onChange={() => this.setState({ product_group_type: "multi" })}
                                                        />
                                                        <span className={"OwLabel mb-0"}>
                                                            <FormattedMessage id={"multi"} defaultMessage={"_multi_"} />
                                                        </span>
                                                    </label>
                                                </div>
                                                {hasItems && (
                                                    <span className={"text-muted small"}>
                                                        <OwLabel title={"product_group_type_locked"} noBottomMargin />
                                                    </span>
                                                )}
                                            </div>
                                        );
                                    })()}

                                {/* Display style — only for multi groups */}
                                {this.state.product_group_type === "multi" && (
                                    <div className={"mb-3 d-flex align-items-center gap-3"}>
                                        <OwLabel title={"product_group_display_style"} isBold={true} noBottomMargin />
                                        <OwSelectOption
                                            titleProp={"title"}
                                            valueProp={"id"}
                                            fn={this.handleChange}
                                            name={"product_group_display_style"}
                                            options={SystemConst.ProductGroupDisplayStyleOptions}
                                            selectedOption={this.state}
                                            selectedOptionProp={"product_group_display_style"}
                                            translateTitle={true}
                                        />
                                    </div>
                                )}

                                {/* Flat group editor (existing, unchanged) */}
                                {(this.state.product_group_type === "flat" || !this.state.product_group_type) && (
                                    <ProductGroupDetail
                                        catalogGuid={this.props.catalogGuid}
                                        groupCatalogItems={groupCatalogItems}
                                        updateGroupItemsFn={this.updateGroupItems}
                                    />
                                )}

                                {/* Multi group editor */}
                                {this.state.product_group_type === "multi" && (
                                    <MultiProductGroupDetail
                                        catalogGuid={this.props.catalogGuid}
                                        initialSections={this.state.multi_group_items}
                                        updateSectionsFn={this.updateMultiGroupSections}
                                    />
                                )}
                            </div>
                        ) : null}
                        {!this.state.is_product_group && this.state.catalog_item?.Group_Catalog_Item ? (
                            <div className={"mt-3"}>
                                <OwLabel title={"product_group"} postText={":"} className={"me-2"} isBold={true} />
                                {this.state.catalog_item?.Group_Catalog_Item?.name}
                                <div className={"d-flex"}>
                                    <div className={"me-2"}>
                                        <i className={"fad fa-info-circle"} />
                                    </div>
                                    <div className={"text-small text-muted w-35r"}>
                                        This item is not searchable in Order Entry since it belongs to a Product Group.
                                        <br />
                                        The Product Group has to be searched to find and add the item.
                                    </div>
                                </div>
                            </div>
                        ) : null}

                        <div className={"category mt-5"}>
                            <div className={"bd-callout"}>
                                <OwLabel title={"category"} description={"Category"} leftIconClass={"fad fa-layer-group"} />
                            </div>
                            <div>
                                <CategorySelection
                                    socket={this.props.socket}
                                    catalogGuid={this.props.catalogGuid}
                                    userModel={this.props.userModel}
                                    supplierModel={this.props.supplierModel}
                                    setCategoryId={this.setCategoryId}
                                    catalogItem={this.state.catalog_item}
                                    catalogItemAttributes={this.state.catalogItemAttributes}
                                    onAttributesChange={this.handleAttributesChange}
                                />
                            </div>
                        </div>

                        {this.props.supplierModel.has_child_items && this.state.catalog_item ? (
                            <CatalogItemChildItemDetail
                                parentCatalogItem={this.state.catalog_item}
                                socket={this.props.socket}
                                catalogGuid={this.props.catalogGuid}
                                updateChildItems={this.updateChildItems}
                                notifyFn={this.props.notifyFn}
                            />
                        ) : null}
                        {this.state.is_kit ? (
                            <div className={"kit mt-5"}>
                                <div className={"bd-callout"}>
                                    <OwLabel title={"kit_options"} leftIconClass={"fad fa-boxes-stacked"} />
                                </div>
                                <div className={"mt-3"}>
                                    <a href={"https://learn.orderwerks.com/kits"} target={"_blank"} className={"pointer"} rel="noreferrer">
                                        <OwLabel
                                            className={"pointer"}
                                            leftIconClass={"fad fa-external-link"}
                                            title={"understanding_kits_and_options"}
                                        />
                                    </a>
                                </div>

                                <hr />

                                <div>
                                    <OwToggle
                                        label={"is_advanced_kit"}
                                        name={"is_advanced_kit"}
                                        active={this.state.is_advanced_kit || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>

                                <div className={"mt-2"}>
                                    <OwToggle
                                        label={"is_kit_builder"}
                                        name={"is_kit_builder"}
                                        active={this.state.is_kit_builder || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>

                                {this.state.is_advanced_kit ? (
                                    <div>
                                        <OwToggle
                                            label={"has_kit_base_options"}
                                            name={"has_kit_base_options"}
                                            active={this.state.has_kit_base_options || false}
                                            fn={this.handleChange}
                                            labelOnRight={true}
                                        />
                                    </div>
                                ) : null}

                                {this.props.supplierModel.Supplier_Integration.has_qbo ? <div></div> : null}

                                {this.state.has_kit_base_options && this.state.is_advanced_kit ? (
                                    <div>
                                        <div>
                                            <OwToggle
                                                label={"kit_add_each_item"}
                                                name={"kit_add_each_item"}
                                                active={this.state.kit_add_each_item || false}
                                                fn={this.handleChange}
                                                labelOnRight={true}
                                            />
                                        </div>

                                        <div>
                                            <OwToggle
                                                label={"kit_item_option_addl_charge"}
                                                name={"kit_item_option_addl_charge"}
                                                active={this.state.kit_item_option_addl_charge || false}
                                                fn={this.handleChange}
                                                labelOnRight={true}
                                            />
                                        </div>
                                    </div>
                                ) : null}

                                {this.state.is_advanced_kit ? (
                                    <div>
                                        <OwToggle
                                            label={"qbo_bundle_each_option_own_line_item"}
                                            name={"qbo_bundle_each_option_own_line_item"}
                                            active={this.state.qbo_bundle_each_option_own_line_item || false}
                                            fn={this.handleChange}
                                            labelOnRight={true}
                                        />
                                    </div>
                                ) : null}

                                <hr />

                                {this.state.is_kit_builder && this.state.catalog_item ? (
                                    <>
                                        {/* Base Items Section */}
                                        <div className="mb-3">
                                            <OwLabel title={"base_items"} leftIconClass={"fas fa-lock"} isBold={true} />
                                            <p className="text-muted text-small mb-2">
                                                Items automatically included in every kit (cannot be removed by customer)
                                            </p>
                                            <KitDetail
                                                mapItems={this.state.kit_builder_base_items as IKit_Catalog_Items_MapUI[]}
                                                updateKitItemsFn={this.updateKitBuilderBaseItemsFn}
                                                socket={this.props.socket}
                                                notify={this.props.notifyFn}
                                                catalogGuid={this.props.catalogGuid}
                                                userModel={this.props.userModel}
                                                supplierModel={this.props.supplierModel}
                                                hasKitBaseOptions={false}
                                                isAdvancedKit={false}
                                            />
                                        </div>

                                        <hr />

                                        {/* Kit Builder Options Section */}
                                        <CatalogItemKitBuilder
                                            catalogItem={this.state.catalog_item}
                                            catalogGuid={this.props.catalogGuid}
                                            updateFn={this.updateKitBuilderOptions}
                                        />
                                    </>
                                ) : (
                                    <KitDetail
                                        mapItems={this.state.kit_items}
                                        updateKitItemsFn={this.updateKitItemsFn}
                                        socket={this.props.socket}
                                        notify={this.props.notifyFn}
                                        catalogGuid={this.props.catalogGuid}
                                        userModel={this.props.userModel}
                                        supplierModel={this.props.supplierModel}
                                        hasKitBaseOptions={this.state.has_kit_base_options}
                                        isAdvancedKit={this.state.is_advanced_kit}
                                    />
                                )}
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_bom ? (
                            <MaterialsDetail
                                materialsQtySet={this.state.materialsQtySet}
                                updateMaterialsFn={this.updateMaterials}
                                deleteMaterialsFn={this.deleteMaterial}
                                socket={this.props.socket}
                                notify={this.props.notifyFn}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                materials={this.state.materials}
                            />
                        ) : null}

                        {/* Bill of materials (OR-1457): gated on has_bom_v2 (not the legacy Materials flag above). */}
                        {this.props.supplierModel.has_bom_v2 ? (
                            <div className={"mt-3 mb-3"}>
                                <OwLabel title={"bill_of_materials_components"} isBold={true} />
                                <BomDetail
                                    lines={this.state.bom_lines}
                                    updateLinesFn={this.updateBomLines}
                                    socket={this.props.socket}
                                    catalogGuid={this.props.catalogGuid}
                                    userModel={this.props.userModel}
                                    supplierModel={this.props.supplierModel}
                                    parentCatalogItemId={this.state.catalog_item?.id}
                                    disabled={!!this.state.existingCatalogItem && !this.state.bom_lines_loaded}
                                    shortagesByComponentId={CreateCatalogItemSidebar.bomShortagesFromItem(this.state.catalog_item)}
                                />
                            </div>
                        ) : null}

                        {this.state.catalog_item && this.state.hasLoaded && (
                            <CatalogItemSidebarItemOptionSection
                                catalogGuid={this.props.catalogGuid}
                                catalogId={this.props.catalogModel.id}
                                catalogItemId={this.state.catalog_item.id}
                                selectedItemOptions={this.state.selectedItemOptions}
                                updateItemOptions={this.updateItemOptions}
                            />
                        )}

                        {this.props.supplierModel.has_automation && this.state.catalog_item ? (
                            <AutomationDetail
                                socket={this.props.socket}
                                notify={this.props.notifyFn}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                automations={this.state.catalog_item.Automations || []}
                                updateAutomationsFn={this.updateAutomations}
                                deleteAutomationsFn={this.deleteAutomations}
                            />
                        ) : null}

                        {this.props.supplierModel.has_discounts ? (
                            <div className={"category mt-5"}>
                                <div className={"bd-callout"}>
                                    <OwLabel title={"discounts"} description={"Discounts"} leftIconClass={"fad fa-dollar"} />
                                </div>
                                <div className={"mt-2"}>
                                    <OwToggle
                                        label={"skip_discount"}
                                        name={"skip_discount"}
                                        active={this.state.skip_discount || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                                <div className={"mt-2"}>
                                    <DiscountAssignment
                                        socket={this.props.socket}
                                        setDiscounts={this.setDiscounts}
                                        selectedDiscounts={this.state.catalog_item?.Discounts || []}
                                    />
                                </div>
                            </div>
                        ) : null}

                        {this.props.supplierModel.Supplier_Integration.has_taxjar ? (
                            <div className={"mt-3"}>
                                <div className={"d-flex"}>
                                    <img src={taxJarLogoSrc} height={"16px"} style={{ marginBottom: ".3rem" }} />
                                    <OwLabel title={"category"} noBottomMargin={true} className={"ms-2"} />
                                    <div className={"ms-auto"}>
                                        <a
                                            href={"https://developers.taxjar.com/api/reference/#categories"}
                                            className={"pointer"}
                                            target={"_blank"}
                                            rel="noreferrer">
                                            <OwLabel className={"pointer"} title={"reference"} leftIconClass={"fad fa-share-square"} />
                                        </a>
                                    </div>
                                </div>
                                <Typeahead
                                    isSelectableFn={() => {
                                        return true;
                                    }}
                                    typeaheadApiFn={this.getTaxJarCategories}
                                    typeaheadItems={this.state.taxJarCategories}
                                    title={"taxjar_category_id"}
                                    titleProp={"name"}
                                    subTitleProp={"product_tax_code"}
                                    selectedItemFn={this.selectTaxJarCategory}
                                    selectedItem={this.state.selectedTaxJarCategory}
                                    selectedItemTitleProp={"name"}
                                    maxResults={20}
                                    scrollableList={true}
                                />
                                {this.state.selectedTaxJarCategory ? this.state.selectedTaxJarCategory.product_tax_code : null}
                            </div>
                        ) : null}

                        <div className={"images mt-5"}>
                            <div className={"bd-callout"}>
                                <OwLabel title={"images"} description={"Images Title"} leftIconClass={"fad fa-image"} />
                            </div>

                            <div className={"d-flex flex-column flex-md-row"}>
                                <div className={"image-item"}>
                                    <OwLabel title={"main"} description={"Main Image"} />
                                    <OwCatalogImagePhotoSet
                                        isProcessed={this.isImageProcessed}
                                        imageSeq={1}
                                        totalSeq={4}
                                        catalogItem={catalogItem}
                                        deleteImageFn={this.deleteFileUpload}
                                    />
                                </div>
                                <div className={"image-item ms-1 me-1"}>
                                    <OwLabel title={"additional"} description={"Additional Image"} />
                                    <OwCatalogImagePhotoSet
                                        isProcessed={this.isImageProcessed}
                                        imageSeq={2}
                                        totalSeq={4}
                                        catalogItem={catalogItem}
                                        deleteImageFn={this.deleteFileUpload}
                                    />
                                </div>
                                <div className={"image-item me-1"}>
                                    <div className={"empty-label"}>&nbsp;</div>
                                    <OwCatalogImagePhotoSet
                                        isProcessed={this.isImageProcessed}
                                        imageSeq={3}
                                        totalSeq={4}
                                        catalogItem={catalogItem}
                                        deleteImageFn={this.deleteFileUpload}
                                    />
                                </div>
                                <div className={"image-item"}>
                                    <div className={"empty-label"}>&nbsp;</div>
                                    <OwCatalogImagePhotoSet
                                        isProcessed={this.isImageProcessed}
                                        imageSeq={4}
                                        totalSeq={4}
                                        catalogItem={catalogItem}
                                        deleteImageFn={this.deleteFileUpload}
                                    />
                                </div>
                            </div>
                            <div className={""}>
                                <OwLabel className={"faded-orange mt-2"} title={"max_size_25_mb"} />
                                <div>
                                    <OwTranslate defaultMessage={"allowed_file_types"} id={"allowed_file_types"} />: JPG, BMP, PNG
                                </div>
                            </div>
                        </div>

                        {catalogItem ? (
                            <div className={"mt-5 mb-5 spec-file position-relative"}>
                                <OwLabel title={"files"} noBottomMargin={true} leftIconClass={"fad fa-file-alt"} />
                                <div>
                                    <OwS3Uploader
                                        socket={this.props.socket}
                                        userModel={this.props.userModel!}
                                        supplierModel={this.props.supplierModel}
                                        isReadOnly={false}
                                        resourceType={FileUploadResourceTypeEnum.catalogItemFileAttachmentOne}
                                        catalogItemGuid={catalogItem.guid}
                                        maxFileSize={52428800}
                                    />
                                </div>

                                <FilesDownloadSection catalogItem={catalogItem} readOnly={false} className={"position-relative"} />
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_order_bonus ? (
                            <div className={"mt-5 mb-5"}>
                                <OwToggle
                                    label={"exclude_bonus_qty"}
                                    name={"exclude_bonus_qty"}
                                    fn={this.handleChange}
                                    active={this.state.exclude_bonus_qty || false}
                                    labelOnRight={true}
                                />
                            </div>
                        ) : null}

                        {!this.state.is_product_group ? (
                            <div>
                                <div className={"bd-callout"}>
                                    <OwLabel title={"price_details"} leftIconClass={"fad fa-dollar-sign"} />
                                </div>

                                {this.props.supplierModel.has_pricing_formulas ? (
                                    <div className={"mt-2 mb-4"}>
                                        <div className={"d-flex"}>
                                            <OwLabel title={"pricing_formula"} noBottomMargin={true} />
                                        </div>
                                        <TypeaheadFn
                                            lookupFn={this.getPricingFormulas}
                                            availableOptions={this.state.pricingFormulas}
                                            titleProp={"name"}
                                            subTitleProp={"expression_template"}
                                            renderFn={(item: IPricing_Formula) => {
                                                let expressionTemplate = item.expression_template;

                                                if (this.props.supplierModel.length_for_depth) {
                                                    expressionTemplate = expressionTemplate.replaceAll("depth", "length");
                                                }

                                                return (
                                                    <div>
                                                        <div>{item.name}</div>
                                                        <div className={"text-muted text-small"}>{expressionTemplate}</div>
                                                    </div>
                                                );
                                            }}
                                            selectedOptionFn={this.selectPricingFormula}
                                            selectedOption={this.state.selectedPricingFormula}
                                            isScrollable={true}
                                            clearSelectionFn={() => {
                                                this.setState({
                                                    selectedPricingFormula: undefined,
                                                    pricing_formula_id: null,
                                                });
                                            }}
                                        />
                                        {this.state.selectedPricingFormula ? (
                                            <div className={"mt-2 text-muted"}>
                                                Formula:{" "}
                                                {this.props.supplierModel.length_for_depth
                                                    ? this.state.selectedPricingFormula.expression_template.replaceAll("depth", "length")
                                                    : this.state.selectedPricingFormula.expression_template}
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}

                                {this.props.supplierModel.has_price_bands && (
                                    <div className={"mt-2 mb-2"}>
                                        <OwToggle
                                            label={"has_price_bands"}
                                            name={"has_price_bands"}
                                            active={this.state.has_price_bands}
                                            fn={this.handleChange}
                                            labelOnRight={true}
                                        />
                                    </div>
                                )}

                                <OwLabel title={"price_per_unit"} description={"Price / Unit Title"} leftIconClass={"fad fa-tag"} />

                                <div>
                                    <OwLabel title={"msrp"} isUppercase={true} noBottomMargin={true} />
                                    <OwInputWrapper fn={this.handleChange} name={"msrp"} value={this.state.msrp} placeholder={"msrp"} />
                                </div>

                                {this.props.supplierModel.has_map ? (
                                    <div className={"mt-2"}>
                                        <OwLabel title={"map"} isUppercase={true} noBottomMargin={true} />
                                        <OwInputWrapper fn={this.handleChange} name={"map"} value={this.state.map} placeholder={"map"} />
                                    </div>
                                ) : null}

                                {this.props.supplierModel.below_min_price_approval ? (
                                    <div className={"mt-2"}>
                                        <OwLabel title={"min_price"} noBottomMargin={true} />
                                        <OwInputWrapper
                                            fn={this.handleChange}
                                            name={"min_price"}
                                            value={this.state.min_price}
                                            placeholder={"min_price"}
                                        />
                                    </div>
                                ) : null}

                                {this.props.supplierModel.has_cost_pricing ? (
                                    <div className={"mt-2"}>
                                        <OwLabel title={"cost"} noBottomMargin={true} />
                                        {this.state.has_price_bands && !!this.props.supplierModel.has_price_bands ? (
                                            <CatalogItemPriceBandBuilder
                                                handleBandUpdate={this.handlePriceBandChange}
                                                catalogId={this.props.catalogModel.id}
                                                catalogItem={this.state.catalog_item}
                                                isCost={true}
                                                band={this.state.priceBands?.cost || []}
                                            />
                                        ) : (
                                            <OwInputWrapper
                                                fn={this.handleChange}
                                                name={"cost_per_uom"}
                                                value={this.state.cost_per_uom}
                                                placeholder={"cost"}
                                            />
                                        )}
                                    </div>
                                ) : null}

                                <hr />

                                <div className={"mt-3 mb-3"}>
                                    <OwToggle
                                        label={"is_taxable"}
                                        name={"is_taxable"}
                                        active={this.state.is_taxable || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>

                                <div>
                                    <div className={"bd-callout"}>
                                        <OwLabel title={"price_groups"} leftIconClass={"fad fa-tags"} />
                                    </div>

                                    {this.state.priceGroups.length > 0 && (
                                        <CatalogItemSidebarPriceGroupInputs
                                            catalogModel={this.props.catalogModel}
                                            catalogItem={this.state.catalog_item}
                                            hasPriceBands={this.state.has_price_bands && !!this.props.supplierModel.has_price_bands}
                                            priceBands={this.state.priceBands || {}}
                                            pricing={this.state.pricing || {}}
                                            pricingDescriptions={this.state.pricing_descriptions || {}}
                                            priceGroups={this.state.priceGroups}
                                            costPerUom={this.state.cost_per_uom}
                                            handleUpdatePricing={this.handleUpdatePricing}
                                            handleDescriptionUpdate={this.handlePricingDescriptionChange}
                                            handleBandUpdate={this.handlePriceBandChange}
                                        />
                                    )}
                                </div>

                                <div className={"bd-callout"}>
                                    <OwLabel title={"qty_details"} leftIconClass={"fad fa-conveyor-belt-boxes"} />
                                </div>

                                {this.props.supplierModel.has_qty_break ? (
                                    <div className={"mt-4"}>
                                        <div>
                                            <OwLabel title={"qty_break"} />
                                        </div>
                                        <div>
                                            <OwInputWrapper name={"qty_break"} fn={this.handleChange} value={this.state.qty_break} />
                                        </div>
                                        <div className={"mt-2"}>
                                            <OwLabel title={"qty_break_price"} />
                                        </div>
                                        <div>
                                            <OwInputWrapper
                                                name={"qty_break_price"}
                                                fn={this.handleChange}
                                                value={this.state.qty_break_price}
                                                disablePrecisionCheck={true}
                                            />
                                        </div>
                                    </div>
                                ) : null}

                                <div className={"mt-5"}>
                                    <OwLabel title={"min_order_qty"} />
                                    <OwInputWrapper
                                        name={"min_order_qty"}
                                        fn={this.handleChange}
                                        value={this.state.min_order_qty}
                                        placeholder={"min_order_qty"}
                                    />
                                </div>

                                <div className={"mt-5"}>
                                    <OwLabel title={"max_order_qty"} />
                                    <OwInputWrapper
                                        name={"max_order_qty"}
                                        fn={this.handleChange}
                                        value={this.state.max_order_qty}
                                        placeholder={"max_order_qty"}
                                    />
                                </div>

                                <div className={"mt-5"}>
                                    <OwLabel title={"unit_incr_qty"} />
                                    <OwInputWrapper
                                        name={"unit_incr_qty"}
                                        fn={this.handleChange}
                                        value={this.state.unit_incr_qty}
                                        placeholder={"unit_incr_qty"}
                                    />
                                </div>

                                <div className={"mt-5"}>
                                    <OwToggle
                                        label={"has_pack_qty"}
                                        name={"has_pack_qty"}
                                        active={!!this.state.has_pack_qty}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>

                                {this.state.has_pack_qty ? (
                                    <div>
                                        <div className={"mt-5"}>
                                            <OwLabel title={"pack_qty"} />
                                            <OwInputWrapper
                                                name={"pack_qty"}
                                                fn={this.handleChange}
                                                value={this.state.pack_qty}
                                                placeholder={"pack_qty"}
                                            />
                                        </div>

                                        <div className={"mt-5"}>
                                            <OwToggle
                                                label={"price_per_pack"}
                                                name={"price_per_pack"}
                                                active={!!this.state.price_per_pack}
                                                fn={this.handleChange}
                                                labelOnRight={true}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            // Product groups carry no price of their own, so the price details above are skipped
                            // for them. Their per-price-group availability (pricing "N/A") is edited here instead,
                            // in the same place a supplier finds pricing for every other item, and it always
                            // renders, including when the group is unavailable in every price group.
                            <ProductGroupPriceGroupAvailability
                                priceGroups={this.state.priceGroups}
                                pricing={this.state.pricing || {}}
                                handleUpdatePricing={this.handleUpdatePricing}
                            />
                        )}

                        <div className={"mt-5"}>
                            <OwLabel
                                title={"unit_of_measurement"}
                                description={"Unit Of Measurement Title"}
                                leftIconClass={"fad fa-ruler"}
                            />
                            {unitMeasurementSelectOption}
                        </div>

                        {this.props.supplierModel.has_uom_sets ? (
                            <div className={"mt-3"}>
                                <UomSetCatalogItem
                                    setUomSet={this.setUomSet}
                                    setPurchaseBaseUnitId={this.setPurchasingUomId}
                                    baseUnit={this.state.catalog_item?.Base_Unit}
                                    purchaseBaseUnitId={this.state.catalog_item?.purchasing_base_unit_id}
                                />
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_catch_weights ? (
                            <div className={"mt-3"}>
                                <OwToggle
                                    label={"is_catch_weight"}
                                    name={"is_catch_weight"}
                                    active={this.state.is_catch_weight || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                />
                            </div>
                        ) : null}

                        <div className={"mt-5"}>
                            <div>
                                <OwLabel title={"linear_feet"} postText={":"} className={"me-2"} />
                                {this.state.catalog_item?.linear_feet}
                            </div>
                        </div>

                        <div className={"mt-2"}>
                            <div>
                                <OwLabel title={"sq_feet"} postText={":"} className={"me-2"} />
                                {this.state.catalog_item?.sq_feet}
                            </div>
                        </div>

                        {/* <div className={!_.isNil(this.state.supplierModel) && this.state.supplierModel.Supplier_Integration.has_qbo? '' : 'd-none'}>
                        <label className="pointer">
                            <input checked={this.state.createItemInQuickBooksOnline} type="checkbox" name="createItemInQuickBooksOnline" className="pointer me-2" onChange={this.handleSupplierChange}/>
                            Create In QuickBooks Online?
                        </label>
                    </div> */}
                        {!this.state.is_product_group ? (
                            <div className={"mt-4"}>
                                <OwToggle
                                    label={"require_addl_input"}
                                    name={"require_addl_input"}
                                    active={this.state.require_addl_input || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                />
                            </div>
                        ) : null}

                        {this.state.require_addl_input ? (
                            <div className="mt-4">
                                <OwLabel title={"addl_input_description"} />
                                <OwInputWrapper
                                    value={this.state.addl_input_description}
                                    name={"addl_input_description"}
                                    fn={this.handleChange}
                                />
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_product_sources ? (
                            <div className={"mt-3 mb-3"}>
                                {this.state.has_alternate_sourcing ? (
                                    <div>
                                        <OwLabel leftIconClass={"fad fa-share-alt"} title={"sources"} />
                                        <ProductSourcesDetail
                                            catalogModel={this.props.catalogModel}
                                            catalogGuid={this.props.catalogGuid}
                                            socket={this.props.socket}
                                            notify={this.props.notifyFn}
                                            userModel={this.props.userModel}
                                            supplierModel={this.props.supplierModel}
                                            productSources={this.state.productSources || []}
                                            updateProductSourcesFn={this.updateProductSources}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_purchase_orders ? (
                            <div className={"mt-3 mb-3"}>
                                <div className={"bd-callout"}>
                                    <OwLabel title={"vendor_sources"} leftIconClass={"fad fa-handshake"} />
                                </div>
                                <div>
                                    <VendorSourcesDetail
                                        catalogModel={this.props.catalogModel}
                                        catalogGuid={this.props.catalogGuid}
                                        vendorSources={this.state.vendorSources || []}
                                        updateVendorSourcesFn={this.updateVendorSources}
                                        defaultVendorSourceId={this.state.defaultVendorSourceId}
                                        catalogItem={this.state.catalog_item}
                                        handleBandUpdate={this.handlePriceBandChange}
                                        priceBands={this.state.priceBands || {}}
                                    />
                                </div>
                            </div>
                        ) : null}

                        {this.props.supplierModel.has_purchase_orders ? (
                            <div>
                                <hr />

                                <div>
                                    <OwLabel title={"vendor_source_locations"} isBold={true} />
                                </div>
                                <div className={"mb-2"}>
                                    <OwSelectOption
                                        name={"vendorSource"}
                                        options={this.props.vendorSources || []}
                                        titleProp={"name"}
                                        valueProp={"id"}
                                        selectedOption={this.state.selectedVendorSource}
                                        selectedOptionProp={"id"}
                                        showBlankFirst={true}
                                        fn={this.selectVendorSource}
                                    />
                                    <OwSelectOption
                                        name={"vendorSourceLocation"}
                                        options={this.state.selectedVendorSource?.Vendor_Source_Locations || []}
                                        titleProp={"name"}
                                        valueProp={"id"}
                                        selectedOption={this.state.selectedVendorSourceLocation}
                                        selectedOptionProp={"id"}
                                        fn={this.selectVendorSourceLocation}
                                        isDisabled={!this.state.selectedVendorSource}
                                        showBlankFirst={true}
                                        className={"mt-2"}
                                    />
                                    <div className={"mt-2"}>
                                        <OwButton title={"add"} fn={this.addLocation} />
                                    </div>
                                </div>

                                <div>
                                    <table
                                        className={
                                            "table " +
                                            (UIService.getThemeType(this.props.supplierModel, this.props.userModel).themeType === "LIGHT"
                                                ? ""
                                                : "table-dark")
                                        }>
                                        <tbody>
                                            {(this.state.selectedVendorSourceLocations || []).map((location, index: number) => {
                                                return (
                                                    <tr key={location.guid} className={location.deleteFlag ? "text-strikethrough" : ""}>
                                                        <td>
                                                            <i
                                                                className={"me-2 fas fa-times text-danger pointer"}
                                                                onClick={() => {
                                                                    this.removeLocation(location, index);
                                                                }}
                                                            />
                                                            {location.Vendor_Source!.name}
                                                        </td>
                                                        <td>{location.name}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <hr />
                            </div>
                        ) : null}

                        {!this.state.is_product_group && this.props.supplierModel.has_inventory ? (
                            <>
                                <div className={"bd-callout"}>
                                    <OwLabel title={"inventory"} leftIconClass={"fad fa-inventory"} />
                                </div>
                                <div className={"mt-3"}>
                                    <OwToggle
                                        label={"ordered_on_demand"}
                                        name={"is_ordered_on_demand"}
                                        active={this.state.is_ordered_on_demand || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>
                                {this.props.supplierModel.has_bom_v2 ? (
                                    <div className={"mt-3"}>
                                        <OwToggle
                                            label={"component_item"}
                                            name={"is_component"}
                                            active={this.state.is_component || false}
                                            fn={this.handleChange}
                                            labelOnRight={true}
                                        />
                                        <div className={"text-muted text-small"}>
                                            <OwLabel title={"help_text_is_component"} noBottomMargin={true} />
                                        </div>
                                    </div>
                                ) : null}
                                <div className={"mt-3"}>
                                    <OwToggle
                                        label={"has_inventory"}
                                        name={"has_inventory"}
                                        active={this.state.has_inventory || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                        disabled={!!this.state.catalog_item?.qbd_ListID || false}
                                    />
                                </div>
                            </>
                        ) : null}

                        {!this.state.is_product_group && this.state.has_inventory ? (
                            <>
                                <div>
                                    <OwToggle
                                        label={"allow_backorder"}
                                        name={"allow_backorder"}
                                        active={this.state.allow_backorder}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                    />
                                </div>

                                {this.state.allow_backorder ? (
                                    <div className={"mt-2"}>
                                        <div>
                                            <OwLabel title={"backorder_limit"} />
                                        </div>
                                        <div>
                                            <OwFnInput
                                                fn={this.handleChange}
                                                name={"backorder_limit"}
                                                value={this.state.backorder_limit}
                                                type={"number"}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </>
                        ) : null}

                        <div className={this.state.has_inventory ? "" : "d-none"}>
                            {this.state.has_alternate_sourcing ? (
                                <div className={"mt-2 text-warning"}>
                                    <OwLabel title={"inventory_controlled_by_source_items"} />
                                </div>
                            ) : null}
                            {this.props.supplierModel.has_warehouses ? (
                                <div className={"mt-2 text-warning"}>
                                    <OwLabel title={"inventory_controlled_by_warehouses"} />
                                </div>
                            ) : null}
                            {this.state.catalog_item?.Material_Catalog_Item_Maps?.length ? (
                                <div className={"mt-2 text-warning"}>
                                    <OwLabel title={"inventory_controlled_by_materials_available"} />
                                </div>
                            ) : null}

                            {this.props.supplierModel.has_warehouses ? null : (
                                <div>
                                    <div className={"mt-2"}>
                                        <OwLabel title={"row"} />
                                        <OwFnInput
                                            type={"text"}
                                            placeholder={"row"}
                                            value={this.state.row}
                                            name={"row"}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                    <div className={"mb-2"}>
                                        <OwLabel title={"bin"} />
                                        <OwFnInput
                                            type={"text"}
                                            placeholder={"bin"}
                                            value={this.state.bin}
                                            name={"bin"}
                                            fn={this.handleChange}
                                        />
                                    </div>
                                </div>
                            )}

                            <div>
                                <OwLabel title={"qty_on_hand"} description={"Qty. On Hand Title"} noBottomMargin={true} />
                                <OwFnInput
                                    type={"number"}
                                    placeholder={"qty_on_hand"}
                                    value={this.state.qty_on_hand}
                                    name={"qty_on_hand"}
                                    fn={this.handleChange}
                                    disabled={
                                        this.state.has_alternate_sourcing ||
                                        this.props.supplierModel.has_warehouses ||
                                        !!this.state.catalog_item?.Material_Catalog_Item_Maps?.length
                                    }
                                />
                            </div>

                            {this.props.supplierModel.has_warehouses ? (
                                <div className={"mt-3 mb-3"}>
                                    <WarehouseDetail
                                        warehouseMap={this.state.warehouseMap || []}
                                        notifyFn={this.props.notifyFn}
                                        socket={this.props.socket}
                                        catalog_item={this.state.catalog_item}
                                        userModel={this.props.userModel}
                                        supplierModel={this.props.supplierModel}
                                        updateWarehouseMapFn={this.updateWarehouseMap}
                                    />
                                </div>
                            ) : null}

                            <div>
                                <OwLabel title={"qty_incoming"} description={"Qty. Incoming"} noBottomMargin={true} />
                                <OwFnInput
                                    type={"number"}
                                    placeholder={"qty_incoming"}
                                    value={this.state.qty_incoming}
                                    name={"qty_incoming"}
                                    fn={this.handleChange}
                                    disabled={this.state.has_alternate_sourcing || this.props.supplierModel.has_warehouses}
                                />
                            </div>

                            <div>
                                <OwLabel title={"reserved_qty_on_hand"} description={"Reserved Qty. On Hand Title"} noBottomMargin={true} />
                                <OwFnInput
                                    type={"number"}
                                    placeholder={"reserved_qty_on_hand"}
                                    value={this.state.reserved_qty_on_hand}
                                    name={"reserved_qty_on_hand"}
                                    fn={this.handleChange}
                                    disabled={true}
                                />
                            </div>

                            <div>
                                <OwLabel title={"max_qty_on_hand"} description={"Max. Qty. On Hand Title"} noBottomMargin={true} />
                                <OwFnInput
                                    type={"number"}
                                    placeholder={"max_qty_on_hand"}
                                    value={this.state.max_qty_on_hand}
                                    name={"max_qty_on_hand"}
                                    fn={this.handleChange}
                                />
                            </div>

                            <div>
                                <OwLabel title={"min_qty_on_hand"} description={"Min. Qty. On Hand Title"} noBottomMargin={true} />
                                <OwFnInput
                                    type={"number"}
                                    placeholder={"min_qty_on_hand"}
                                    value={this.state.min_qty_on_hand}
                                    name={"min_qty_on_hand"}
                                    fn={this.handleChange}
                                />
                            </div>

                            <div>
                                <OwLabel title={"packs"} description={"Packs"} noBottomMargin={true} />
                                <OwInputWrapper
                                    type={"number"}
                                    placeholder={"packs"}
                                    value={this.state.packs}
                                    name={"packs"}
                                    fn={this.handleChange}
                                />
                            </div>

                            <div className={"d-flex flex-column gap-2 mt-3"}>
                                <OwToggle
                                    label={"has_serials"}
                                    name={"has_serials"}
                                    active={this.state.has_serials || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                />

                                {this.state.has_serials && (
                                    <div className="d-flex align-items-center">
                                        <OwToggle
                                            label={"nfa_item"}
                                            name={"is_nfa"}
                                            active={this.state.is_nfa || false}
                                            fn={this.handleChange}
                                            labelOnRight={true}
                                        />
                                        <OwIconTooltip
                                            iconClassName="ms-2 text-muted fas fa-info-circle"
                                            tooltipContent="nfa_item_tooltip"
                                            translateContent={true}
                                        />
                                    </div>
                                )}

                                {this.state.has_serials && this.props.supplierModel.has_serial_production && (
                                    <div className="d-flex align-items-center">
                                        <OwToggle
                                            label={"bypass_production_workflow"}
                                            name={"bypass_production_workflow"}
                                            active={this.state.bypass_production_workflow || false}
                                            fn={this.handleChange}
                                            labelOnRight={true}
                                        />
                                        <OwIconTooltip
                                            iconClassName="ms-2 text-muted fas fa-info-circle"
                                            tooltipContent="bypass_production_workflow_tooltip"
                                            translateContent={true}
                                        />
                                    </div>
                                )}

                                <div className="d-flex align-items-center">
                                    <OwToggle
                                        label={"manual_serial_entry"}
                                        name={"manual_serial_entry"}
                                        active={this.state.manual_serial_entry || false}
                                        fn={this.handleChange}
                                        labelOnRight={true}
                                        disabled={!this.state.has_serials}
                                    />

                                    <OwIconTooltip
                                        iconClassName="ms-2 text-muted fas fa-info-circle"
                                        tooltipContent="manual_serial_entry_tooltip"
                                        translateContent={true}
                                    />
                                </div>

                                <div>
                                    <OwLabel title={"max_serials_per_order_item"} />
                                    <OwFnInput
                                        fn={this.handleChange}
                                        name={"max_serials_per_order_item"}
                                        value={this.state.max_serials_per_order_item}
                                        disabled={!this.state.manual_serial_entry}
                                    />
                                </div>
                            </div>
                        </div>

                        {/*<div className={show_common_items_modal ? "" : "d-none"}>*/}
                        {/*    <OwCheckbox*/}
                        {/*        label={"is_common_item"}*/}
                        {/*        name={"is_common_item"}*/}
                        {/*        checked={this.state.is_common_item}*/}
                        {/*        fn={this.handleChange}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        {has_qbo ? (
                            <CatalogItemSidebarQboSection
                                createInQbo={this.state.create_in_qbo}
                                catalogItem={this.state.catalog_item}
                                updateStateFn={(updatedState: any) => {
                                    this.setState(updatedState);
                                }}
                            />
                        ) : null}
                        {has_qbd ? (
                            <CatalogItemSidebarQbdSection
                                createInQbd={this.state.create_in_qbd}
                                catalogItem={this.state.catalog_item}
                                updateStateFn={(updatedState: any) => {
                                    this.setState(updatedState);
                                }}
                            />
                        ) : null}

                        <div className={"mt-3"}>
                            <OwToggle
                                label={"active"}
                                name={"active"}
                                active={this.state.active || false}
                                fn={this.handleChange}
                                labelOnRight={true}
                            />
                        </div>
                    </div>

                    <div className={"p-2 border-top"}>
                        <div className={""}>
                            <OwButton
                                disabled={!this.state.formValid}
                                active={this.state.activeSaveCatalogItem}
                                leftIconClass=""
                                className="btn-primary me-2"
                                title="save"
                                fn={this.save}
                            />

                            <OwButton className={"btn-danger"} fn={this.cancel} title={"cancel"} />
                        </div>

                        {!this.state.existingCatalogItem && (
                            <div>
                                <OwToggle
                                    wrapperClassName={"mt-2"}
                                    label={"create_another"}
                                    name={"createAnother"}
                                    active={this.state.createAnother || false}
                                    fn={this.handleChange}
                                    labelOnRight={true}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* Kit Builder Conversion Modal */}
                {this.state.showKitBuilderConversionModal && (
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
                        <div className="bg-dark p-4 rounded" style={{ maxWidth: "500px" }}>
                            <OwTitle title={"convert_kit_items"} tag="h4" />
                            <p className="mt-3">
                                You have existing kit items. What would you like to do with them when switching to Kit Builder mode?
                            </p>
                            <div className="mt-4 d-flex flex-column gap-2">
                                <OwButton
                                    title={"convert_to_base_items"}
                                    fn={this.handleKitBuilderConversionConvert}
                                    className="btn-primary w-100"
                                />
                                <OwButton
                                    title={"start_fresh"}
                                    fn={this.handleKitBuilderConversionStartFresh}
                                    className="btn-secondary w-100"
                                />
                                <OwButton
                                    title={"cancel"}
                                    fn={this.handleKitBuilderConversionCancel}
                                    className="btn-outline-danger w-100"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default CreateCatalogItemSidebar;
